(function () {
  'use strict';
  // YourMelody — Création guidée v2 (achat direct).
  // Mêmes écrans que le quiz de l'extrait (quiz-lead-v2), puis souvenir physique, livraison, panier, checkout.
  // Les propriétés de ligne restent celles du quiz v1 (Pour qui, Prénom, Style, Voix, Occasion, Qualités, Souvenirs, Difficultés, Message) + Note studio.
  var root = document.getElementById('ym-quiz-p2');
  if (!root) return;

  var rawLoc = (root.dataset.locale || 'fr').toLowerCase();
  var loc = rawLoc.slice(0, 2);
  var LOC = ['en', 'de', 'es', 'ja', 'it', 'nl', 'sv', 'da', 'nb', 'pt', 'fi'].indexOf(loc) > -1 ? loc : 'fr';   // 21/10 : + es, ja, it, nl
  var VARIANTS = {}; try { VARIANTS = JSON.parse(root.dataset.variants || '{}'); } catch (e) { VARIANTS = {}; }
  var PRICES = {}; try { var pEl = document.getElementById('ymqp-prices'); if (pEl) PRICES = JSON.parse(pEl.textContent || '{}'); } catch (e) { PRICES = {}; }
  var IMAGES = {
    plaque: { fr: root.dataset.imgPlaqueFr || '', en: root.dataset.imgPlaqueEn || '', de: root.dataset.imgPlaqueDe || '' },
    magnet: { fr: root.dataset.imgMagnetFr || '', en: root.dataset.imgMagnetEn || '', de: root.dataset.imgMagnetDe || '' }
  };
  // 22/10 : es, ja, it, nl ont leurs visuels (attributs data-img-*-loc poses par la section seulement dans ces langues)
  if (root.dataset.imgPlaqueLoc && ['es', 'ja', 'it', 'nl', 'sv', 'da', 'nb', 'pt', 'fi'].indexOf(LOC) > -1) IMAGES.plaque[LOC] = root.dataset.imgPlaqueLoc;
  if (root.dataset.imgMagnetLoc && ['es', 'ja', 'it', 'nl', 'sv', 'da', 'nb', 'pt', 'fi'].indexOf(LOC) > -1) IMAGES.magnet[LOC] = root.dataset.imgMagnetLoc;
  var checkoutUrl = root.dataset.checkoutUrl || '/checkout';

  // ============================================================
  //  i18n — FR / EN / DE (copie du quiz extrait + écrans achat)
  // ============================================================
  var I18N = {
    fr: {
      privacy: "Vos réponses restent privées",
      back: "Retour", skip: "Passer", skipPhysical: "Non merci, continuer sans", next: "Continuer", stepWord: "Étape", ofWord: "sur",
      ctaFinal: "Commander ma chanson",
      submitting: "Préparation de votre commande…", uploading: "Envoi de votre photo…",
      stepNames: ["Le destinataire", "Le style", "Sa personnalité", "Vos souvenirs", "Le mot du cœur", "Récapitulatif", "Vos options", "Un objet déco"],
      ask: {"wife": "Comment s'appelle votre femme ?", "husband": "Comment s'appelle votre mari ?", "girlfriend": "Comment s'appelle votre copine ?", "boyfriend": "Comment s'appelle votre copain ?", "mother": "Comment s'appelle votre mère ?", "father": "Comment s'appelle votre père ?", "child": "Comment s'appellent vos enfants ?", "friend": "Comment s'appelle votre ami(e) ?", "self": "Quel est votre prénom ?", "other": "Comment s'appelle cette personne ?"},
      s2_titlePre: "Quel style pour ",
      s2_titlePost: "&nbsp;?",
      s4_titlePre: "Vos plus beaux souvenirs avec ",
      s4_titlePost: "",
      s5_titlePre: "Un mot du cœur pour ",
      s5_titlePost: "&nbsp;?",
      p6_titlePre: "Un objet déco pour ",
      p6_titlePost: "&nbsp;?",
      ctaNoThanks: "Non merci",
      g_title: "Garantie satisfait ou remboursé",
      g_body: "Révisions illimitées jusqu'à ce que la chanson vous plaise, ou remboursement intégral.",
      o_delivPrefix: "Livrée le",
      t_secure: "Paiement sécurisé",
      t_refund: "Satisfait ou remboursé",
      t_free: "Modifications gratuites",
      faqTitle: "Questions fréquentes",
      faq: [["Comment vais-je recevoir ma chanson ?", "Votre chanson vous est envoyée par e-mail en MP3 haute qualité, avec un lien privé pour l'écouter, la télécharger et la partager."], ["Le paiement est-il sécurisé ?", "Oui. Tous les paiements passent par Shopify, avec un chiffrement de niveau bancaire. Nous ne conservons jamais vos coordonnées bancaires."], ["Puis-je demander des modifications ?", "Bien sûr. On retouche la chanson gratuitement jusqu'à ce qu'elle vous plaise."], ["Combien de temps avant de la recevoir ?", "Comptez 48 heures en livraison standard. Avec l'option 24 heures, votre chanson est prête dès demain."]],
      r_title: "Vérifiez les détails de votre chanson",
      x_title: "Découvrez quelques-unes de nos réalisations",
      o_cardTitle: "Chanson pour",
      o_cardEdit: "Modifier",
      o_express: "Livraison 24h",
      o_expressMeta: "Même chanson, livrée sous 24 heures",
      o_stream: "Votre chanson sur Spotify et Apple Music",
      o_streamMeta: "Ajoutez-la à vos playlists du quotidien.",
      o_lyr: "Gardez ses paroles pour toujours",
      o_lyrMeta: "Imprimables, avec son prénom et la pochette de la chanson. À garder, à offrir, à encadrer.",
      o_eyebrow: "Vos options",
      o_title: "Complétez votre chanson",
      o_sub: "Ces options rendent le cadeau plus complet.",
      o_paroles: "Les paroles imprimables",
      o_parolesMeta: "Le texte de sa chanson, prêt à encadrer",
      o_songLine: "Votre chanson personnalisée",
      o_optLabel: "Ajoutez à votre chanson",
      o_uncheck: "Décochez ce dont vous n'avez pas besoin",
      r_eyebrow: "Presque fini",
      r_sub: "Relisez vos réponses. Tout se modifie en un clic.",
      r_edit: "Modifier",
      r_pour: "Pour",
      r_occ: "Occasion",
      r_style: "Style",
      r_voice: "Voix",
      r_qual: "Ses qualités",
      r_mem: "Vos souvenirs",
      r_msg: "Le mot du cœur",
      r_vide: "Non précisé",
      r_photoTitle: "Ajoutez une photo",
      r_photoSub: "Elle apparaîtra sur la page de sa chanson.",
      r_photoBtn: "Choisir une photo",
      r_photoFree: "Offert",
      r_photoDone: "Photo ajoutée",
      r_photoChange: "Changer",
      r_photoConv: "Conversion de votre photo…",
      r_photoErrType: "Ce format de photo n'est pas accepté. Essayez une photo JPG ou PNG.",
      r_photoErrBig: "Cette photo est trop lourde. Essayez une photo plus légère.",
      occLabel: "À quelle occasion&nbsp;?", occOtherPh: "Précisez l'occasion…",
      occasions: [
        { em: "🎂", label: "Anniversaire" }, { em: "💞", label: "Anniversaire de couple / mariage" }, { em: "💍", label: "Mariage" }, { em: "👶", label: "Naissance" }, { em: "🌅", label: "Retraite" },
        { em: "🕊️", label: "Hommage" }, { em: "❤️", label: "Saint-Valentin" }, { em: "🌷", label: "Fête des mères / pères" }, { em: "🎄", label: "Noël" },
        { em: "✨", label: "Juste comme ça" }, { em: "✍️", label: "Autre" }
      ],
      diffLabel: "Une épreuve traversée ensemble&nbsp;?", diffPh: "Une maladie, la distance, un deuil… ce que vous avez surmonté à deux.",
      s1_title: "Pour qui est cette chanson&nbsp;?", s1_sub: "Parlez-nous de la personne qui compte.",
      nameLabel: "Son prénom", namePh: "Ex. Sophie", s1_errRecipient: "Choisissez pour qui est la chanson.", s1_errName: "Indiquez son prénom : il sera chanté dans le refrain.",
      s2_errStyle: "Choisissez un style musical.", s2_errVoice: "Choisissez le genre de voix.",
      recipients: [
        { key: "wife", em: "💍", label: "Ma femme", rel: "femme", cat: "partner", g: "f" },
        { key: "husband", em: "🤵", label: "Mon mari", rel: "mari", cat: "partner", g: "m" },
        { key: "girlfriend", em: "💖", label: "Ma copine", rel: "copine", cat: "partner", g: "f" },
        { key: "boyfriend", em: "💙", label: "Mon copain", rel: "copain", cat: "partner", g: "m" },
        { key: "mother", em: "🌷", label: "Ma mère", rel: "mère", cat: "parent", g: "f" },
        { key: "father", em: "🌳", label: "Mon père", rel: "père", cat: "parent", g: "m" },
        { key: "child", em: "👶", label: "Mes enfants", rel: "enfant", cat: "child", g: "n" },
        { key: "friend", em: "🤝", label: "Un(e) ami(e)", rel: "ami(e)", cat: "other", g: "n" },
        { key: "self", em: "🎁", label: "Pour moi", rel: "moi", cat: "other", g: "n" },
        { key: "other", em: "✨", label: "Quelqu'un qui compte", rel: "personne qui compte", cat: "other", g: "n" }
      ],
      s2_eyebrow: "L'ambiance", s2_title: "Quel style pour la chanson&nbsp;?", s2_sub: "Choisissez le style qui colle à votre histoire.",
      topTag: "Top",
      stylesPop: ["Variété française", "Surprenez-moi", "Ballade romantique", "Country", "Pop", "Piano", "R&B", "Rock"],
      stylesExtra: ["Rap", "Soul", "Ouverture de bal / Mariage", "Oriental", "Latino", "Afro beats", "Métal", "Reggae", "Disco", "Classique", "Orchestre", "Autre"],
      moreStyles: "Plus de styles ▾", lessStyles: "Moins de styles ▴",
      voiceLabel: "Genre de voix souhaité", voiceHint: "Nous vous conseillons de choisir votre propre genre : la chanson paraît alors plus personnelle.", voices: ["Chanteuse", "Chanteur", "Peu importe"],
      s3_eyebrow: "Sa personnalité", s3_titlePre: "Qu'est-ce qui rend ", s3_titleName: "cette personne", s3_titlePost: " spécial(e)&nbsp;?", s3_sub: "Décrivez son caractère et les qualités que vous aimez le plus.",
      qualities: ["Attentionné(e)", "Généreux(se)", "Drôle", "Doux(ce)", "Fort(e)", "Bienveillant(e)", "Passionné(e)", "Complice", "Courageux(se)", "Spontané(e)", "Fidèle", "Lumineux(se)"],
      qmoreLabel: "Ses plus belles qualités", qmorePh: "Sa patience, sa sagesse, son humour, sa façon de protéger et d'encourager… Qu'est-ce qui en fait quelqu'un d'extraordinaire ?", facult: "facultatif",
      s4_eyebrow: "Vos moments", s4_title: "Vos plus beaux souvenirs", memPh: "Comment vous vous êtes rencontrés, les années qui comptent, les blagues que vous seuls comprenez, les moments qui ont fait votre histoire…", memHint: "Plus c'est précis (lieux, dates, surnoms), plus la chanson sera émouvante.",
      memSubs: {
        partner: "Quels moments partagés avec cette personne comptent le plus pour vous ?",
        parent: "Quels moments partagés avec cette personne comptent le plus pour vous ?",
        child: "Quels moments partagés avec cette personne comptent le plus pour vous ?",
        other: "Quels moments partagés avec cette personne comptent le plus pour vous ?"
      },
      prompts: {
        partner: ["Notre rencontre…", "Un fou rire ensemble…", "Un moment qui compte…"],
        parent: ["Un souvenir d'enfance…", "Ce qu'il ou elle m'a appris…", "Une habitude qui vous fait sourire…"],
        child: ["Le jour de sa naissance…", "Un moment rien qu'à vous…", "Ce qui vous rend fier(e)…"],
        other: ["Comment vous vous êtes connus…", "Un souvenir marquant…", "Ce qui vous lie…"]
      },
      s5_eyebrow: "Le cœur", s5_title: "Un mot du cœur&nbsp;?", s5_sub: "Un message personnel que vous aimeriez retrouver dans la chanson.",
      msgPH: { f: "Je veux qu'elle sache que…", m: "Je veux qu'il sache que…", n: "Ce que j'aimerais lui dire, c'est…" },
      studioLabel: "Un dernier mot pour le studio ?", studioPh: "Une envie, une chose à éviter, un détail qui compte…",
      p6_eyebrow: "Le cadeau", p6_title: "Un objet déco&nbsp;?", p6_sub: "Une plaque ou un magnet avec le QR code de votre chanson, livré chez vous.",
      p6_plaque: "Plaque QR", p6_magnet: "Magnet QR", p6_socle: "Ajouter le socle en bois",
      p6_titleLabel: "Titre de la chanson", p6_titlePh: "Le titre que vous voulez voir inscrit", p6_titleMax: "40 caractères maximum",
      p6_artistLabel: "Artiste", p6_artistPh: "Une signature, un clin d'œil, un surnom", p6_artistMax: "30 caractères maximum",
      p6_photoLabel: "Photo de couverture", p6_photoBtn: "Choisissez une photo", p6_photoHelp: "JPG, PNG, WEBP ou photo iPhone · 20 Mo max",
      p6_errFields: "Indiquez le titre et l'artiste à inscrire.", p6_errPhoto: "Une photo est requise pour ce produit.",
      p6_errPhotoBig: "Photo trop volumineuse (max 20 Mo).", p6_errPhotoType: "Format non supporté. Utilisez JPG, PNG ou WEBP.", p6_converting: "Conversion de la photo iPhone…",
      p7_eyebrow: "Dernière étape", p7_title: "Livraison &amp; écoute", p7_sub: "Choisissez comment et quand recevoir votre chanson.",
      p7_deliveryLabel: "Livraison de la chanson", p7_std: "Standard", p7_stdMeta: "Sous 48 h · par email", p7_stdPrice: "Inclus",
      p7_express: "Express", p7_expressMeta: "Sous 24 h · prioritaire",
      p7_diffusionLabel: "Diffusion", p7_streaming: "Streaming Spotify & Apple Music", p7_streamingMeta: "Votre chanson sur toutes les plateformes",
      p7_sessions: "Prochaines sessions d'enregistrement",
      sessions: { delivery: "Livraison le", reserved: "RÉSERVÉ", days: ["Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi"], months: ["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"] },
      errGeneric: "Une erreur est survenue. Vérifiez votre connexion et réessayez.",
      props: { recipient: "Pour qui", firstName: "Prénom", style: "Style", voice: "Voix", occasion: "Occasion", qualities: "Qualités", memories: "Souvenirs", difficulties: "Difficultés", message: "Message", studio: "Note studio", songTitle: "Titre de la chanson", artist: "Artiste", socle: "Socle", yes: "Oui" }
    },
    en: {
      privacy: "Your answers stay private",
      back: "Back", skip: "Skip", skipPhysical: "No thanks, continue without", next: "Continue", stepWord: "Step", ofWord: "of",
      ctaFinal: "Order my song",
      submitting: "Preparing your order…", uploading: "Uploading your photo…",
      stepNames: ["The recipient", "The style", "Their personality", "Your memories", "A word from the heart", "Summary", "Your options", "A keepsake"],
      ask: {"wife": "What's your wife's name?", "husband": "What's your husband's name?", "girlfriend": "What's your girlfriend's name?", "boyfriend": "What's your boyfriend's name?", "mother": "What's your mother's name?", "father": "What's your father's name?", "child": "What are your children's names?", "friend": "What's your friend's name?", "self": "What's your first name?", "other": "What's their name?"},
      s2_titlePre: "Which style for ",
      s2_titlePost: "?",
      s4_titlePre: "Your best memories with ",
      s4_titlePost: "",
      s5_titlePre: "A word from the heart for ",
      s5_titlePost: "?",
      p6_titlePre: "A keepsake for ",
      p6_titlePost: "?",
      ctaNoThanks: "No thanks",
      g_title: "Money-back guarantee",
      g_body: "Unlimited revisions until you love the song, or a full refund.",
      o_delivPrefix: "Delivered on",
      t_secure: "Secure payment",
      t_refund: "Money-back guarantee",
      t_free: "Free changes",
      faqTitle: "Frequently asked questions",
      faq: [["How will I receive my song?", "Your song arrives by email as a high-quality MP3, with a private link to listen, download and share it."], ["Is the payment secure?", "Yes. All payments go through Shopify, with bank-level encryption. We never store your card details."], ["Can I ask for changes?", "Of course. We rework the song for free until you love it."], ["How long before I get it?", "Around 48 hours with standard delivery. With the 24-hour option, your song is ready tomorrow."]],
      r_title: "Check your song details",
      x_title: "Discover a few of our songs",
      o_cardTitle: "Song for",
      o_cardEdit: "Edit",
      o_express: "24-hour delivery",
      o_expressMeta: "Same song, delivered within 24 hours",
      o_stream: "Your song on Spotify and Apple Music",
      o_streamMeta: "Add it to your everyday playlists.",
      o_lyr: "Keep their lyrics forever",
      o_lyrMeta: "Printable, with their name and the song artwork. To keep, to give, to frame.",
      o_eyebrow: "Your options",
      o_title: "Complete your song",
      o_sub: "These options make the gift more complete.",
      o_paroles: "Printable lyrics",
      o_parolesMeta: "The words of their song, ready to frame",
      o_songLine: "Your personalised song",
      o_optLabel: "Add to your song",
      o_uncheck: "Untick anything you don't need",
      r_eyebrow: "Almost there",
      r_sub: "Read your answers again. Everything can be changed in one click.",
      r_edit: "Edit",
      r_pour: "For",
      r_occ: "Occasion",
      r_style: "Style",
      r_voice: "Voice",
      r_qual: "Their qualities",
      r_mem: "Your memories",
      r_msg: "A word from the heart",
      r_vide: "Not specified",
      r_photoTitle: "Add a photo",
      r_photoSub: "It will appear on their song page.",
      r_photoBtn: "Choose a photo",
      r_photoFree: "Free",
      r_photoDone: "Photo added",
      r_photoChange: "Change",
      r_photoConv: "Converting your photo…",
      r_photoErrType: "This photo format isn't supported. Try a JPG or PNG.",
      r_photoErrBig: "This photo is too large. Try a smaller one.",
      occLabel: "What's the occasion?", occOtherPh: "Tell us the occasion…",
      occasions: [
        { em: "🎂", label: "Birthday" }, { em: "💍", label: "Wedding" }, { em: "👶", label: "Birth" }, { em: "🌅", label: "Retirement" },
        { em: "🕊️", label: "Tribute" }, { em: "❤️", label: "Valentine's Day" }, { em: "🌷", label: "Mother's / Father's Day" }, { em: "🎄", label: "Christmas" },
        { em: "✨", label: "Just because" }, { em: "✍️", label: "Other" }
      ],
      diffLabel: "A hard time you went through together?", diffPh: "An illness, distance, a loss… what you overcame together.",
      s1_title: "Who is this song for?", s1_sub: "Tell us about the person who matters.",
      nameLabel: "Their first name", namePh: "e.g. Sophie", s1_errRecipient: "Please choose who the song is for.", s1_errName: "Please enter their first name: it will be sung in the chorus.",
      s2_errStyle: "Please choose a music style.", s2_errVoice: "Please choose a voice.",
      recipients: [
        { key: "wife", em: "💍", label: "My wife", rel: "wife", cat: "partner", g: "f" },
        { key: "husband", em: "🤵", label: "My husband", rel: "husband", cat: "partner", g: "m" },
        { key: "girlfriend", em: "💖", label: "My girlfriend", rel: "girlfriend", cat: "partner", g: "f" },
        { key: "boyfriend", em: "💙", label: "My boyfriend", rel: "boyfriend", cat: "partner", g: "m" },
        { key: "mother", em: "🌷", label: "My mother", rel: "mother", cat: "parent", g: "f" },
        { key: "father", em: "🌳", label: "My father", rel: "father", cat: "parent", g: "m" },
        { key: "child", em: "👶", label: "My children", rel: "child", cat: "child", g: "n" },
        { key: "friend", em: "🤝", label: "A friend", rel: "friend", cat: "other", g: "n" },
        { key: "self", em: "🎁", label: "For myself", rel: "myself", cat: "other", g: "n" },
        { key: "other", em: "✨", label: "Someone who matters", rel: "someone dear", cat: "other", g: "n" }
      ],
      s2_eyebrow: "The vibe", s2_title: "Which style for the song?", s2_sub: "Pick the style that fits your story.",
      topTag: "Top",
      stylesPop: ["Country", "Romantic Ballad", "Surprise me", "Pop", "R&B", "Folk", "Piano", "Rock"],
      stylesExtra: ["Rap / Hip-Hop", "Soul", "First Dance / Wedding", "Oriental", "Latin", "Afro Beats", "Metal", "Reggae", "Disco", "Classical", "Orchestra", "Other"],
      moreStyles: "More styles ▾", lessStyles: "Fewer styles ▴",
      voiceLabel: "Preferred voice gender", voiceHint: "We recommend choosing your own gender, so the vocals feel more personal.", voices: ["Female singer", "Male singer", "No preference"],
      s3_eyebrow: "Their personality", s3_titlePre: "What makes ", s3_titleName: "this person", s3_titlePost: " special?", s3_sub: "Describe their character and the qualities you love most.",
      qualities: ["Caring", "Generous", "Funny", "Gentle", "Strong", "Kind", "Passionate", "Close", "Brave", "Spontaneous", "Loyal", "Radiant"],
      qmoreLabel: "Their beautiful qualities", qmorePh: "Patient, wise, funny, protective, always there when it counts? Tell us what makes them the person they are.", facult: "optional",
      s4_eyebrow: "Your moments", s4_title: "Your most precious memories", memPh: "How you met, the years that mattered, the jokes only the two of you get, the moments that made your story…", memHint: "The more precise (places, dates, nicknames), the more moving the song.",
      memSubs: {
        partner: "Which moments with them mean the most to you?",
        parent: "Which moments with them mean the most to you?",
        child: "Which moments with them mean the most to you?",
        other: "Which moments with them mean the most to you?"
      },
      prompts: {
        partner: ["How we met…", "A shared laugh…", "A moment that matters…"],
        parent: ["A childhood memory…", "What they taught me…", "A habit that makes you smile…"],
        child: ["The day they were born…", "A moment just for you two…", "What makes you proud…"],
        other: ["How you met…", "A memorable moment…", "What connects you…"]
      },
      s5_eyebrow: "The heart", s5_title: "A word from the heart?", s5_sub: "A personal message you'd like to hear in the song.",
      msgPH: { f: "I want her to know that…", m: "I want him to know that…", n: "What I'd like to tell them is…" },
      studioLabel: "One last word for the studio?", studioPh: "A wish, something to avoid, a detail that matters…",
      p6_eyebrow: "The gift", p6_title: "A keepsake?", p6_sub: "A plaque or a magnet with the QR code of your song, delivered to your home.",
      p6_plaque: "QR plaque", p6_magnet: "QR magnet", p6_socle: "Add the wooden base",
      p6_titleLabel: "Song title", p6_titlePh: "The title you want engraved", p6_titleMax: "40 characters maximum",
      p6_artistLabel: "Artist", p6_artistPh: "A signature, a wink, a nickname", p6_artistMax: "30 characters maximum",
      p6_photoLabel: "Cover photo", p6_photoBtn: "Choose a photo", p6_photoHelp: "JPG, PNG, WEBP or iPhone photo · 20 MB max",
      p6_errFields: "Please enter the title and the artist to engrave.", p6_errPhoto: "A photo is required for this product.",
      p6_errPhotoBig: "Photo too large (max 20 MB).", p6_errPhotoType: "Unsupported format. Use JPG, PNG or WEBP.", p6_converting: "Converting iPhone photo…",
      p7_eyebrow: "Last step", p7_title: "Delivery &amp; listening", p7_sub: "Choose how and when to receive your song.",
      p7_deliveryLabel: "Song delivery", p7_std: "Standard", p7_stdMeta: "Within 48h · by email", p7_stdPrice: "Included",
      p7_express: "Express", p7_expressMeta: "Within 24h · priority",
      p7_diffusionLabel: "Streaming", p7_streaming: "Spotify & Apple Music streaming", p7_streamingMeta: "Your song on all platforms",
      p7_sessions: "Upcoming recording sessions",
      sessions: { delivery: "Delivery on", reserved: "RESERVED", days: ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"], months: ["January","February","March","April","May","June","July","August","September","October","November","December"] },
      errGeneric: "Something went wrong. Check your connection and try again.",
      props: { recipient: "For whom", firstName: "First name", style: "Music style", voice: "Voice", occasion: "Occasion", qualities: "Qualities", memories: "Memories", difficulties: "Hard times", message: "Message", studio: "Studio note", songTitle: "Song title", artist: "Artist", socle: "Wooden base", yes: "Yes" }
    },
    de: {
      privacy: "Ihre Antworten bleiben privat",
      back: "Zurück", skip: "Überspringen", skipPhysical: "Nein danke, ohne weiter", next: "Weiter", stepWord: "Schritt", ofWord: "von",
      ctaFinal: "Mein Lied bestellen",
      submitting: "Bestellung wird vorbereitet…", uploading: "Foto wird hochgeladen…",
      stepNames: ["Empfänger", "Der Stil", "Persönlichkeit", "Ihre Erinnerungen", "Ein Wort von Herzen", "Zusammenfassung", "Ihre Optionen", "Ein Dekostück"],
      ask: {"wife": "Wie heißt Ihre Frau?", "husband": "Wie heißt Ihr Mann?", "girlfriend": "Wie heißt Ihre Freundin?", "boyfriend": "Wie heißt Ihr Freund?", "mother": "Wie heißt Ihre Mutter?", "father": "Wie heißt Ihr Vater?", "child": "Wie heißen Ihre Kinder?", "friend": "Wie heißt Ihr Freund oder Ihre Freundin?", "self": "Wie heißen Sie?", "other": "Wie heißt diese Person?"},
      s2_titlePre: "Welcher Stil für ",
      s2_titlePost: "?",
      s4_titlePre: "Ihre schönsten Erinnerungen mit ",
      s4_titlePost: "",
      s5_titlePre: "Ein Wort von Herzen für ",
      s5_titlePost: "?",
      p6_titlePre: "Ein Dekostück für ",
      p6_titlePost: "?",
      ctaNoThanks: "Nein danke",
      g_title: "Zufrieden oder Geld zurück",
      g_body: "Unbegrenzte Überarbeitungen, bis Ihnen das Lied gefällt, oder volle Rückerstattung.",
      o_delivPrefix: "Geliefert am",
      t_secure: "Sichere Zahlung",
      t_refund: "Zufrieden oder Geld zurück",
      t_free: "Kostenlose Änderungen",
      faqTitle: "Häufige Fragen",
      faq: [["Wie erhalte ich mein Lied?", "Ihr Lied kommt per E-Mail als hochwertige MP3, mit einem privaten Link zum Anhören, Herunterladen und Teilen."], ["Ist die Zahlung sicher?", "Ja. Alle Zahlungen laufen über Shopify, mit Verschlüsselung auf Bankniveau. Wir speichern Ihre Kartendaten nie."], ["Kann ich Änderungen verlangen?", "Selbstverständlich. Wir überarbeiten das Lied kostenlos, bis es Ihnen gefällt."], ["Wie lange dauert es?", "Rund 48 Stunden bei Standardlieferung. Mit der 24-Stunden-Option ist Ihr Lied schon morgen fertig."]],
      r_title: "Prüfen Sie die Details Ihres Liedes",
      x_title: "Entdecken Sie einige unserer Lieder",
      o_cardTitle: "Lied für",
      o_cardEdit: "Ändern",
      o_express: "24-Stunden-Lieferung",
      o_expressMeta: "Gleiches Lied, geliefert innerhalb von 24 Stunden",
      o_stream: "Ihr Lied auf Spotify und Apple Music",
      o_streamMeta: "Fügen Sie es Ihren täglichen Playlists hinzu.",
      o_lyr: "Bewahren Sie den Text für immer",
      o_lyrMeta: "Zum Ausdrucken, mit dem Vornamen und dem Cover des Liedes. Aufbewahren, verschenken, rahmen.",
      o_eyebrow: "Ihre Optionen",
      o_title: "Vervollständigen Sie Ihr Lied",
      o_sub: "Diese Optionen machen das Geschenk vollständiger.",
      o_paroles: "Druckbarer Liedtext",
      o_parolesMeta: "Der Text des Liedes, bereit zum Rahmen",
      o_songLine: "Ihr persönliches Lied",
      o_optLabel: "Zu Ihrem Lied hinzufügen",
      o_uncheck: "Haken Sie ab, was Sie nicht brauchen",
      r_eyebrow: "Fast geschafft",
      r_sub: "Lesen Sie Ihre Antworten noch einmal. Alles lässt sich mit einem Klick ändern.",
      r_edit: "Ändern",
      r_pour: "Für",
      r_occ: "Anlass",
      r_style: "Stil",
      r_voice: "Stimme",
      r_qual: "Ihre Eigenschaften",
      r_mem: "Ihre Erinnerungen",
      r_msg: "Ein Wort von Herzen",
      r_vide: "Nicht angegeben",
      r_photoTitle: "Foto hinzufügen",
      r_photoSub: "Es erscheint auf der Seite des Liedes.",
      r_photoBtn: "Foto auswählen",
      r_photoFree: "Gratis",
      r_photoDone: "Foto hinzugefügt",
      r_photoChange: "Ändern",
      r_photoConv: "Ihr Foto wird konvertiert…",
      r_photoErrType: "Dieses Fotoformat wird nicht unterstützt. Versuchen Sie JPG oder PNG.",
      r_photoErrBig: "Dieses Foto ist zu groß. Versuchen Sie ein kleineres.",
      occLabel: "Zu welchem Anlass?", occOtherPh: "Welcher Anlass?…",
      occasions: [
        { em: "🎂", label: "Geburtstag" }, { em: "💍", label: "Hochzeit" }, { em: "👶", label: "Geburt" }, { em: "🌅", label: "Ruhestand" },
        { em: "🕊️", label: "Gedenken" }, { em: "❤️", label: "Valentinstag" }, { em: "🌷", label: "Mutter- / Vatertag" }, { em: "🎄", label: "Weihnachten" },
        { em: "✨", label: "Einfach so" }, { em: "✍️", label: "Andere" }
      ],
      diffLabel: "Eine schwere Zeit, die Sie gemeinsam durchgestanden haben?", diffPh: "Eine Krankheit, Entfernung, ein Verlust… was Sie zusammen überwunden haben.",
      s1_title: "Für wen ist dieses Lied?", s1_sub: "Erzählen Sie uns von der Person, die zählt.",
      nameLabel: "Ihr Vorname", namePh: "z.B. Sophie", s1_errRecipient: "Bitte wählen Sie, für wen das Lied ist.", s1_errName: "Bitte den Vornamen angeben: er wird im Refrain gesungen.",
      s2_errStyle: "Bitte wählen Sie einen Musikstil.", s2_errVoice: "Bitte wählen Sie eine Stimmlage.",
      recipients: [
        { key: "wife", em: "💍", label: "Meine Frau", rel: "Frau", cat: "partner", g: "f" },
        { key: "husband", em: "🤵", label: "Mein Mann", rel: "Mann", cat: "partner", g: "m" },
        { key: "girlfriend", em: "💖", label: "Meine Freundin", rel: "Freundin", cat: "partner", g: "f" },
        { key: "boyfriend", em: "💙", label: "Mein Freund", rel: "Freund", cat: "partner", g: "m" },
        { key: "mother", em: "🌷", label: "Meine Mutter", rel: "Mutter", cat: "parent", g: "f" },
        { key: "father", em: "🌳", label: "Mein Vater", rel: "Vater", cat: "parent", g: "m" },
        { key: "child", em: "👶", label: "Meine Kinder", rel: "Kind", cat: "child", g: "n" },
        { key: "friend", em: "🤝", label: "Ein(e) Freund(in)", rel: "Freund(in)", cat: "other", g: "n" },
        { key: "self", em: "🎁", label: "Für mich", rel: "mich selbst", cat: "other", g: "n" },
        { key: "other", em: "✨", label: "Jemand Besonderes", rel: "besondere Person", cat: "other", g: "n" }
      ],
      s2_eyebrow: "Die Stimmung", s2_title: "Welcher Stil für das Lied?", s2_sub: "Wählen Sie den Stil, der zu Ihrer Geschichte passt.",
      topTag: "Top",
      stylesPop: ["Deutschpop", "Schlager", "Überrasche mich", "Romantische Ballade", "Pop", "Klavier", "R&B", "Rock"],
      stylesExtra: ["Rap", "Soul", "Eröffnungstanz / Hochzeit", "Orientalisch", "Latino", "Afrobeats", "Metal", "Reggae", "Disco", "Klassik", "Orchester", "Andere"],
      moreStyles: "Mehr Stile ▾", lessStyles: "Weniger Stile ▴",
      voiceLabel: "Gewünschte Stimmlage", voiceHint: "Wir empfehlen, Ihr eigenes Geschlecht zu wählen, so wirkt das Lied persönlicher.", voices: ["Sängerin", "Sänger", "Egal"],
      s3_eyebrow: "Persönlichkeit", s3_titlePre: "Was macht ", s3_titleName: "diese Person", s3_titlePost: " besonders?", s3_sub: "Beschreiben Sie den Charakter und die Eigenschaften, die Sie am meisten lieben.",
      qualities: ["Fürsorglich", "Großzügig", "Lustig", "Sanft", "Stark", "Gütig", "Leidenschaftlich", "Vertraut", "Mutig", "Spontan", "Treu", "Strahlend"],
      qmoreLabel: "Ihre schönsten Eigenschaften", qmorePh: "Geduldig, klug, lustig, beschützend, immer da, wenn es zählt? Erzählen Sie, was diesen Menschen ausmacht.", facult: "optional",
      s4_eyebrow: "Ihre Momente", s4_title: "Ihre schönsten Erinnerungen", memPh: "Wie Sie sich kennengelernt haben, die Jahre, die zählten, Ihre Insider-Witze, die Momente, die Ihre Geschichte ausmachen…", memHint: "Je genauer (Orte, Daten, Spitznamen), desto bewegender das Lied.",
      memSubs: {
        partner: "Welche gemeinsamen Momente bedeuten Ihnen am meisten?",
        parent: "Welche gemeinsamen Momente bedeuten Ihnen am meisten?",
        child: "Welche gemeinsamen Momente bedeuten Ihnen am meisten?",
        other: "Welche gemeinsamen Momente bedeuten Ihnen am meisten?"
      },
      prompts: {
        partner: ["Wie wir uns trafen…", "Ein gemeinsames Lachen…", "Ein Moment, der zählt…"],
        parent: ["Eine Kindheitserinnerung…", "Was er/sie mir beigebracht hat…", "Eine Gewohnheit, die Sie lächeln lässt…"],
        child: ["Der Tag der Geburt…", "Ein Moment nur für Sie beide…", "Worauf Sie stolz sind…"],
        other: ["Wie Sie sich kennenlernten…", "Ein prägender Moment…", "Was Sie verbindet…"]
      },
      s5_eyebrow: "Das Herz", s5_title: "Ein Wort von Herzen?", s5_sub: "Eine persönliche Botschaft, die Sie im Lied hören möchten.",
      msgPH: { f: "Ich möchte, dass sie weiß, dass…", m: "Ich möchte, dass er weiß, dass…", n: "Was ich ihm/ihr sagen möchte, ist…" },
      studioLabel: "Ein letztes Wort für das Studio?", studioPh: "Ein Wunsch, etwas zu vermeiden, ein wichtiges Detail…",
      p6_eyebrow: "Das Geschenk", p6_title: "Ein Dekostück?", p6_sub: "Eine Plakette oder ein Magnet mit dem QR-Code Ihres Liedes, zu Ihnen nach Hause geliefert.",
      p6_plaque: "QR-Plakette", p6_magnet: "QR-Magnet", p6_socle: "Den Holzsockel hinzufügen",
      p6_titleLabel: "Titel des Liedes", p6_titlePh: "Der Titel, der eingraviert werden soll", p6_titleMax: "Maximal 40 Zeichen",
      p6_artistLabel: "Künstler", p6_artistPh: "Eine Unterschrift, ein Augenzwinkern, ein Spitzname", p6_artistMax: "Maximal 30 Zeichen",
      p6_photoLabel: "Titelbild", p6_photoBtn: "Foto auswählen", p6_photoHelp: "JPG, PNG, WEBP oder iPhone-Foto · max. 20 MB",
      p6_errFields: "Bitte Titel und Künstler für die Gravur angeben.", p6_errPhoto: "Ein Foto ist für dieses Produkt erforderlich.",
      p6_errPhotoBig: "Foto zu groß (max. 20 MB).", p6_errPhotoType: "Nicht unterstütztes Format. Verwenden Sie JPG, PNG oder WEBP.", p6_converting: "iPhone-Foto wird konvertiert…",
      p7_eyebrow: "Letzter Schritt", p7_title: "Lieferung &amp; Hören", p7_sub: "Wählen Sie, wie und wann Sie Ihr Lied erhalten möchten.",
      p7_deliveryLabel: "Lieferung des Liedes", p7_std: "Standard", p7_stdMeta: "Innerhalb von 48 Std. · per E-Mail", p7_stdPrice: "Inklusive",
      p7_express: "Express", p7_expressMeta: "Innerhalb von 24 Std. · vorrangig",
      p7_diffusionLabel: "Streaming", p7_streaming: "Spotify & Apple Music Streaming", p7_streamingMeta: "Ihr Lied auf allen Plattformen",
      p7_sessions: "Kommende Aufnahmesitzungen",
      sessions: { delivery: "Lieferung am", reserved: "RESERVIERT", days: ["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"], months: ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"] },
      errGeneric: "Es ist ein Fehler aufgetreten. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      props: { recipient: "Für wen", firstName: "Vorname", style: "Musikstil", voice: "Stimme", occasion: "Anlass", qualities: "Eigenschaften", memories: "Erinnerungen", difficulties: "Schwere Zeiten", message: "Botschaft", studio: "Studio-Notiz", songTitle: "Liedtitel", artist: "Künstler", socle: "Holzsockel", yes: "Ja" }
    },
    es: {
      privacy: "Tus respuestas son privadas",
      back: "Atrás", skip: "Saltar", skipPhysical: "No, gracias, continuar sin recuerdo", next: "Continuar", stepWord: "Paso", ofWord: "de",
      ctaFinal: "Pedir mi canción",
      submitting: "Preparando tu pedido…", uploading: "Enviando tu foto…",
      stepNames: ["La persona", "El estilo", "Su forma de ser", "Vuestros recuerdos", "Desde el corazón", "Resumen", "Tus opciones", "Un recuerdo físico"],
      ask: {"wife": "¿Cómo se llama tu mujer?", "husband": "¿Cómo se llama tu marido?", "girlfriend": "¿Cómo se llama tu novia?", "boyfriend": "¿Cómo se llama tu novio?", "mother": "¿Cómo se llama tu madre?", "father": "¿Cómo se llama tu padre?", "child": "¿Cómo se llaman tus hijos?", "friend": "¿Cómo se llama tu amigo o amiga?", "self": "¿Cómo te llamas?", "other": "¿Cómo se llama esa persona?"},
      s2_titlePre: "¿Qué estilo para ",
      s2_titlePost: "?",
      s4_titlePre: "Tus mejores recuerdos con ",
      s4_titlePost: "",
      s5_titlePre: "¿Unas palabras desde el corazón para ",
      s5_titlePost: "?",
      p6_titlePre: "¿Un recuerdo físico para ",
      p6_titlePost: "?",
      ctaNoThanks: "No, gracias",
      g_title: "Garantía de reembolso",
      g_body: "Cambios ilimitados hasta que la canción te encante, o te devolvemos todo tu dinero.",
      o_delivPrefix: "Entrega el",
      t_secure: "Pago seguro",
      t_refund: "Garantía de reembolso",
      t_free: "Cambios gratis",
      faqTitle: "Preguntas frecuentes",
      faq: [["¿Cómo recibiré mi canción?", "Tu canción llega por email en MP3 de alta calidad, con un enlace privado para escucharla, descargarla y compartirla."], ["¿El pago es seguro?", "Sí. Todos los pagos pasan por Shopify, con cifrado de nivel bancario. Nunca guardamos los datos de tu tarjeta."], ["¿Puedo pedir cambios?", "Por supuesto. Retocamos la canción gratis hasta que te encante."], ["¿Cuánto tarda en llegar?", "Unas 48 horas con la entrega estándar. Con la opción de 24 horas, tu canción está lista mañana."]],
      r_title: "Revisa los detalles de tu canción",
      x_title: "Descubre algunas de nuestras canciones",
      o_cardTitle: "Canción para",
      o_cardEdit: "Editar",
      o_express: "Entrega en 24 horas",
      o_expressMeta: "La misma canción, entregada en 24 horas",
      o_stream: "Tu canción en Spotify y Apple Music",
      o_streamMeta: "Añádela a tus playlists de cada día.",
      o_lyr: "Guarda su letra para siempre",
      o_lyrMeta: "Para imprimir, con su nombre y la portada de la canción. Para guardar, regalar o enmarcar.",
      o_eyebrow: "Tus opciones",
      o_title: "Completa tu canción",
      o_sub: "Estas opciones hacen el regalo todavía más completo.",
      o_paroles: "Letra para imprimir",
      o_parolesMeta: "La letra de su canción, lista para enmarcar",
      o_songLine: "Tu canción personalizada",
      o_optLabel: "Añade a tu canción",
      o_uncheck: "Desmarca lo que no necesites",
      r_eyebrow: "Casi listo",
      r_sub: "Relee tus respuestas. Todo se cambia con un clic.",
      r_edit: "Editar",
      r_pour: "Para",
      r_occ: "Ocasión",
      r_style: "Estilo",
      r_voice: "Voz",
      r_qual: "Sus cualidades",
      r_mem: "Vuestros recuerdos",
      r_msg: "Desde el corazón",
      r_vide: "Sin especificar",
      r_photoTitle: "Añade una foto",
      r_photoSub: "Aparecerá en la página de su canción.",
      r_photoBtn: "Elegir una foto",
      r_photoFree: "Gratis",
      r_photoDone: "Foto añadida",
      r_photoChange: "Cambiar",
      r_photoConv: "Convirtiendo tu foto…",
      r_photoErrType: "Este formato de foto no es compatible. Prueba con una foto JPG o PNG.",
      r_photoErrBig: "Esta foto pesa demasiado. Prueba con una más ligera.",
      occLabel: "¿Para qué ocasión?", occOtherPh: "Cuéntanos la ocasión…",
      occasions: [
        { em: "🎂", label: "Cumpleaños" }, { em: "💞", label: "Aniversario" }, { em: "💍", label: "Boda" }, { em: "👶", label: "Nacimiento" }, { em: "🌅", label: "Jubilación" },
        { em: "🕊️", label: "Homenaje" }, { em: "❤️", label: "San Valentín" }, { em: "🌷", label: "Día de la Madre / del Padre" }, { em: "🕯️", label: "Primera Comunión" }, { em: "🎄", label: "Navidad y Reyes" },
        { em: "✨", label: "Porque sí" }, { em: "✍️", label: "Otra" }
      ],
      diffLabel: "¿Un momento difícil que superasteis juntos?", diffPh: "Una enfermedad, la distancia, una pérdida… lo que superasteis juntos.",
      s1_title: "¿Para quién es esta canción?", s1_sub: "Háblanos de esa persona tan importante.",
      nameLabel: "Su nombre", namePh: "Ej. Carmen", s1_errRecipient: "Elige para quién es la canción.", s1_errName: "Escribe su nombre: lo cantaremos en el estribillo.",
      s2_errStyle: "Elige un estilo musical.", s2_errVoice: "Elige el tipo de voz.",
      recipients: [
        { key: "wife", em: "💍", label: "Mi mujer", rel: "wife", cat: "partner", g: "f" },
        { key: "husband", em: "🤵", label: "Mi marido", rel: "husband", cat: "partner", g: "m" },
        { key: "girlfriend", em: "💖", label: "Mi novia", rel: "girlfriend", cat: "partner", g: "f" },
        { key: "boyfriend", em: "💙", label: "Mi novio", rel: "boyfriend", cat: "partner", g: "m" },
        { key: "mother", em: "🌷", label: "Mi madre", rel: "mother", cat: "parent", g: "f" },
        { key: "father", em: "🌳", label: "Mi padre", rel: "father", cat: "parent", g: "m" },
        { key: "child", em: "👶", label: "Mis hijos", rel: "child", cat: "child", g: "n" },
        { key: "friend", em: "🤝", label: "Un amigo o amiga", rel: "friend", cat: "other", g: "n" },
        { key: "self", em: "🎁", label: "Para mí", rel: "myself", cat: "other", g: "n" },
        { key: "other", em: "✨", label: "Alguien especial", rel: "someone dear", cat: "other", g: "n" }
      ],
      s2_eyebrow: "El ambiente", s2_title: "¿Qué estilo para la canción?", s2_sub: "Elige el estilo que mejor va con vuestra historia.",
      topTag: "Top",
      stylesPop: ["Balada romántica", "Pop español", "Sorpréndeme", "Flamenco pop", "Rumba", "Acústico", "Piano y voz", "Pop rock"],
      stylesExtra: ["Bachata", "Reggaetón suave", "Sevillanas", "Copla", "Indie español", "Hip hop en español", "Boda / Primer baile", "Canción de cuna", "Otro"],
      moreStyles: "Más estilos ▾", lessStyles: "Menos estilos ▴",
      voiceLabel: "Tipo de voz", voiceHint: "Te recomendamos elegir tu mismo género: así la canción se siente más tuya.", voices: ["Voz femenina", "Voz masculina", "Sin preferencia"],
      s3_eyebrow: "Su forma de ser", s3_titlePre: "¿Qué hace tan especial a ", s3_titleName: "esta persona", s3_titlePost: "?", s3_sub: "Describe su carácter y las cualidades que más te gustan.",
      qualities: ["Cariñoso/a", "Generoso/a", "Divertido/a", "Dulce", "Fuerte", "Amable", "Apasionado/a", "Cómplice", "Valiente", "Espontáneo/a", "Leal", "Alegre"],
      qmoreLabel: "Sus mejores cualidades", qmorePh: "Su paciencia, su sentido del humor, cómo te cuida, cómo está ahí cuando hace falta… Cuéntanos qué hace a esta persona tan única.", facult: "opcional",
      s4_eyebrow: "Vuestros momentos", s4_title: "Vuestros recuerdos más bonitos", memPh: "Cómo os conocisteis, los años que importan, las bromas que solo vosotros entendéis, los momentos que han hecho vuestra historia…", memHint: "Cuantos más detalles des (lugares, fechas, apodos), más emocionante será la canción.",
      memSubs: {
        partner: "¿Qué momentos con esta persona son los más importantes para ti?",
        parent: "¿Qué momentos con esta persona son los más importantes para ti?",
        child: "¿Qué momentos con esta persona son los más importantes para ti?",
        other: "¿Qué momentos con esta persona son los más importantes para ti?"
      },
      prompts: {
        partner: ["Cómo nos conocimos…", "Un ataque de risa juntos…", "Un momento especial…"],
        parent: ["Un recuerdo de la infancia…", "Lo que me enseñó…", "Una costumbre que te hace sonreír…"],
        child: ["El día que nació…", "Un momento solo vuestro…", "Lo que más orgullo te da…"],
        other: ["Cómo os conocisteis…", "Un recuerdo que no olvidas…", "Lo que os une…"]
      },
      s5_eyebrow: "El corazón", s5_title: "¿Unas palabras desde el corazón?", s5_sub: "Un mensaje personal que te gustaría escuchar en la canción.",
      msgPH: { f: "Quiero que ella sepa que…", m: "Quiero que él sepa que…", n: "Lo que me gustaría decirle es…" },
      studioLabel: "¿Algo más para el estudio?", studioPh: "Un deseo, algo que evitar, un detalle importante…",
      p6_eyebrow: "El regalo", p6_title: "¿Un recuerdo físico?", p6_sub: "Una placa o un imán con el código QR de tu canción, entregado en tu casa.",
      p6_plaque: "Placa QR", p6_magnet: "Imán QR", p6_socle: "Añadir la base de madera",
      p6_titleLabel: "Título de la canción", p6_titlePh: "El título que quieres grabar", p6_titleMax: "40 caracteres como máximo",
      p6_artistLabel: "Artista", p6_artistPh: "Una firma, un guiño, un apodo", p6_artistMax: "30 caracteres como máximo",
      p6_photoLabel: "Foto de portada", p6_photoBtn: "Elegir una foto", p6_photoHelp: "JPG, PNG, WEBP o foto de iPhone · 20 MB máx.",
      p6_errFields: "Escribe el título y el artista que quieres grabar.", p6_errPhoto: "Este producto necesita una foto.",
      p6_errPhotoBig: "Foto demasiado grande (20 MB máx.).", p6_errPhotoType: "Formato no compatible. Usa JPG, PNG o WEBP.", p6_converting: "Convirtiendo la foto de iPhone…",
      p7_eyebrow: "Último paso", p7_title: "Entrega y escucha", p7_sub: "Elige cómo y cuándo recibir tu canción.",
      p7_deliveryLabel: "Entrega de la canción", p7_std: "Estándar", p7_stdMeta: "En 48 h · por email", p7_stdPrice: "Incluido",
      p7_express: "Exprés", p7_expressMeta: "En 24 h · prioritaria",
      p7_diffusionLabel: "Streaming", p7_streaming: "Streaming en Spotify y Apple Music", p7_streamingMeta: "Tu canción en todas las plataformas",
      p7_sessions: "Próximas sesiones de grabación",
      sessions: { delivery: "Entrega el", reserved: "RESERVADO", days: ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"], months: ["de enero","de febrero","de marzo","de abril","de mayo","de junio","de julio","de agosto","de septiembre","de octubre","de noviembre","de diciembre"] },
      errGeneric: "Ha ocurrido un error. Revisa tu conexión e inténtalo de nuevo.",
      props: { recipient: "Para quién", firstName: "Nombre", style: "Estilo musical", voice: "Voz", occasion: "Ocasión", qualities: "Cualidades", memories: "Recuerdos", difficulties: "Momentos difíciles", message: "Mensaje", studio: "Nota para el estudio", songTitle: "Título de la canción", artist: "Artista", socle: "Base de madera", yes: "Sí" }
    },
    ja: {
      privacy: "ご回答は外部に公開されません",
      back: "戻る", skip: "スキップ", skipPhysical: "いいえ、このまま進む", next: "次へ", stepWord: "ステップ", ofWord: "/",
      ctaFinal: "この歌を注文する",
      submitting: "ご注文を準備しています…", uploading: "写真を送信しています…",
      stepNames: ["贈る相手", "曲のスタイル", "その人らしさ", "思い出", "伝えたい想い", "ご確認", "オプション", "記念グッズ"],
      ask: {"wife": "奥さまのお名前は？", "husband": "旦那さまのお名前は？", "girlfriend": "彼女のお名前は？", "boyfriend": "彼氏のお名前は？", "mother": "お母さまのお名前は？", "father": "お父さまのお名前は？", "child": "お子さまのお名前は？", "friend": "お友だちのお名前は？", "self": "あなたのお名前は？", "other": "その方のお名前は？"},
      s2_titlePre: "",
      s2_titlePost: "にぴったりのスタイルは？",
      s4_titlePre: "",
      s4_titlePost: "とのいちばんの思い出",
      s5_titlePre: "",
      s5_titlePost: "へ伝えたい想いは？",
      p6_titlePre: "",
      p6_titlePost: "への想いを、形に残しませんか？",
      ctaNoThanks: "いいえ、けっこうです",
      g_title: "満足保証・全額返金",
      g_body: "気に入っていただけるまで何度でも修正します。それでもご満足いただけない場合は、全額返金いたします。",
      o_delivPrefix: "お届け予定日",
      t_secure: "安全なお支払い",
      t_refund: "全額返金保証",
      t_free: "修正は無料",
      faqTitle: "よくあるご質問",
      faq: [["歌はどのように届きますか？", "高音質のMP3をメールでお届けします。聴く、ダウンロードする、シェアするための非公開リンクも一緒にお送りします。"], ["お支払いは安全ですか？", "はい。お支払いはすべてShopifyが銀行レベルの暗号化で処理します。カード情報を当店で保存することは一切ありません。"], ["修正をお願いできますか？", "もちろんです。気に入っていただけるまで、何度でも無料で手直しします。"], ["届くまでどのくらいかかりますか？", "通常便でおよそ48時間です。24時間お届けのオプションなら、明日には完成します。"]],
      r_title: "歌の内容をご確認ください",
      x_title: "これまでに制作した歌の一部をご紹介します",
      o_cardTitle: "贈る相手：",
      o_cardEdit: "変更",
      o_express: "24時間以内にお届け",
      o_expressMeta: "同じ歌を24時間以内にお届けします",
      o_stream: "あなたの歌をSpotifyとApple Musicで配信",
      o_streamMeta: "いつものプレイリストに加えて楽しめます。",
      o_lyr: "歌詞を、ずっと手元に",
      o_lyrMeta: "お名前と歌のジャケット入りで、印刷してお使いいただけます。手元に残しても、贈っても、額に入れて飾っても。",
      o_eyebrow: "オプション",
      o_title: "あなたの歌を、もっと特別に",
      o_sub: "オプションを加えると、贈り物がさらに充実します。",
      o_paroles: "印刷用の歌詞",
      o_parolesMeta: "その方の歌の歌詞を、額に入れて飾れる形で",
      o_songLine: "あなただけのオーダーメイドソング",
      o_optLabel: "歌に追加する",
      o_uncheck: "不要なものはチェックを外してください",
      r_eyebrow: "あと少し",
      r_sub: "ご回答を見直してください。どの項目もワンクリックで変更できます。",
      r_edit: "変更",
      r_pour: "贈る相手",
      r_occ: "贈る機会",
      r_style: "スタイル",
      r_voice: "歌声",
      r_qual: "素敵なところ",
      r_mem: "思い出",
      r_msg: "伝えたい想い",
      r_vide: "未記入",
      r_photoTitle: "写真を追加",
      r_photoSub: "その方の歌のページに表示されます。",
      r_photoBtn: "写真を選ぶ",
      r_photoFree: "無料",
      r_photoDone: "写真を追加しました",
      r_photoChange: "変更",
      r_photoConv: "写真を変換しています…",
      r_photoErrType: "この形式の写真には対応していません。JPGかPNGでお試しください。",
      r_photoErrBig: "写真のサイズが大きすぎます。もう少し小さい写真でお試しください。",
      occLabel: "どんな機会に贈りますか？", occOtherPh: "贈る機会を教えてください…",
      occasions: [
        { em: "🎂", label: "誕生日" }, { em: "💞", label: "記念日" }, { em: "💍", label: "結婚式" }, { em: "👶", label: "出産祝い" }, { em: "🌅", label: "退職祝い" },
        { em: "🕊️", label: "追悼" }, { em: "❤️", label: "バレンタイン" }, { em: "🌷", label: "母の日・父の日" }, { em: "🍵", label: "敬老の日" }, { em: "🎄", label: "クリスマス" },
        { em: "✨", label: "特別な理由はなく" }, { em: "✍️", label: "その他" }
      ],
      diffLabel: "ふたりで乗り越えたつらい時期はありますか？", diffPh: "病気、遠距離、大切な人との別れ…ふたりで乗り越えたこと。",
      s1_title: "この歌を贈る相手は？", s1_sub: "大切な方について教えてください。",
      nameLabel: "お名前（呼び名）", namePh: "例：ゆうこ", s1_errRecipient: "贈る相手を選んでください。", s1_errName: "お名前を入力してください。サビで歌われます。",
      s2_errStyle: "曲のスタイルを選んでください。", s2_errVoice: "歌声を選んでください。",
      recipients: [
        { key: "wife", em: "💍", label: "妻", rel: "wife", cat: "partner", g: "f" },
        { key: "husband", em: "🤵", label: "夫", rel: "husband", cat: "partner", g: "m" },
        { key: "girlfriend", em: "💖", label: "彼女", rel: "girlfriend", cat: "partner", g: "f" },
        { key: "boyfriend", em: "💙", label: "彼氏", rel: "boyfriend", cat: "partner", g: "m" },
        { key: "mother", em: "🌷", label: "母", rel: "mother", cat: "parent", g: "f" },
        { key: "father", em: "🌳", label: "父", rel: "father", cat: "parent", g: "m" },
        { key: "child", em: "👶", label: "子ども", rel: "child", cat: "child", g: "n" },
        { key: "friend", em: "🤝", label: "友だち", rel: "friend", cat: "other", g: "n" },
        { key: "self", em: "🎁", label: "自分へ", rel: "myself", cat: "other", g: "n" },
        { key: "other", em: "✨", label: "大切な人", rel: "someone dear", cat: "other", g: "n" }
      ],
      s2_eyebrow: "雰囲気", s2_title: "どんなスタイルの曲にしますか？", s2_sub: "ふたりの物語に合うスタイルを選んでください。",
      topTag: "人気",
      stylesPop: ["J-POP", "ラブバラード", "おまかせ", "アコースティック", "ピアノ", "シティポップ", "ロック", "R&B"],
      stylesExtra: ["アニソン風", "演歌・歌謡曲", "ウェディング", "ヒップホップ", "オーケストラ", "ジャズ", "童謡・子守唄", "その他"],
      moreStyles: "ほかのスタイル ▾", lessStyles: "閉じる ▴",
      voiceLabel: "歌声の希望", voiceHint: "ご自身と同じ性別の歌声を選ぶと、より気持ちが伝わる歌になります。", voices: ["女性ボーカル", "男性ボーカル", "おまかせ"],
      s3_eyebrow: "その人らしさ", s3_titlePre: "", s3_titleName: "この方", s3_titlePost: "の素敵なところは？", s3_sub: "性格や、あなたが大好きなところを教えてください。",
      qualities: ["思いやりがある", "気前がいい", "面白い", "やさしい", "芯が強い", "親切", "情熱的", "そばにいてくれる", "勇敢", "自由", "誠実", "明るい"],
      qmoreLabel: "その方の素敵なところ", qmorePh: "辛抱強い、賢い、面白い、守ってくれる、大事なときにいつもそばにいる？その方らしさを教えてください。", facult: "任意",
      s4_eyebrow: "思い出", s4_title: "いちばん大切な思い出", memPh: "出会い、忘れられない年、ふたりだけの冗談、ふたりの物語をつくった瞬間…", memHint: "場所や日付、呼び名など、具体的に書くほど心に響く歌になります。",
      memSubs: {
        partner: "その方との思い出で、いちばん大切なのはどんな瞬間ですか？",
        parent: "その方との思い出で、いちばん大切なのはどんな瞬間ですか？",
        child: "その子との思い出で、いちばん大切なのはどんな瞬間ですか？",
        other: "その方との思い出で、いちばん大切なのはどんな瞬間ですか？"
      },
      prompts: {
        partner: ["出会ったときのこと…", "ふたりで笑ったこと…", "大切な瞬間…"],
        parent: ["子どもの頃の思い出…", "教えてもらったこと…", "思わず笑ってしまう口ぐせ…"],
        child: ["生まれた日のこと…", "ふたりだけの時間…", "誇らしく思うこと…"],
        other: ["出会ったきっかけ…", "忘れられない出来事…", "ふたりをつなぐもの…"]
      },
      s5_eyebrow: "想い", s5_title: "伝えたい想いはありますか？", s5_sub: "歌の中で伝えたいメッセージを教えてください。",
      msgPH: { f: "彼女に伝えたいのは…", m: "彼に伝えたいのは…", n: "伝えたいのは…" },
      studioLabel: "スタジオへのひとこと（任意）", studioPh: "ご希望、避けてほしいこと、大切なこだわりなど…",
      p6_eyebrow: "贈り物", p6_title: "形に残る記念グッズはいかがですか？", p6_sub: "歌のQRコード入りのプレートまたはマグネットを、ご自宅にお届けします。",
      p6_plaque: "QRプレート", p6_magnet: "QRマグネット", p6_socle: "木製スタンドを追加",
      p6_titleLabel: "曲名", p6_titlePh: "刻印したい曲名", p6_titleMax: "40文字まで",
      p6_artistLabel: "アーティスト名", p6_artistPh: "サイン、ちょっとした遊び心、ニックネームなど", p6_artistMax: "30文字まで",
      p6_photoLabel: "ジャケット写真", p6_photoBtn: "写真を選ぶ", p6_photoHelp: "JPG・PNG・WEBP・iPhoneの写真 · 最大20MB",
      p6_errFields: "刻印する曲名とアーティスト名を入力してください。", p6_errPhoto: "この商品には写真が必要です。",
      p6_errPhotoBig: "写真のサイズが大きすぎます（最大20MB）。", p6_errPhotoType: "対応していない形式です。JPG・PNG・WEBPをお使いください。", p6_converting: "iPhoneの写真を変換しています…",
      p7_eyebrow: "最後のステップ", p7_title: "お届けと配信", p7_sub: "歌の受け取り方とタイミングを選んでください。",
      p7_deliveryLabel: "歌のお届け", p7_std: "通常便", p7_stdMeta: "48時間以内 · メールでお届け", p7_stdPrice: "追加料金なし",
      p7_express: "お急ぎ便", p7_expressMeta: "24時間以内 · 優先制作",
      p7_diffusionLabel: "配信", p7_streaming: "SpotifyとApple Musicで配信", p7_streamingMeta: "あなたの歌をすべての配信サービスで",
      p7_sessions: "今後の収録スケジュール",
      sessions: { delivery: "お届け", reserved: "予約済み", days: ["日","月","火","水","木","金","土"], months: ["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"] },
      errGeneric: "エラーが発生しました。通信環境をご確認のうえ、もう一度お試しください。",
      props: { recipient: "贈る相手", firstName: "お名前", style: "曲のスタイル", voice: "歌声", occasion: "贈る機会", qualities: "人柄", memories: "思い出", difficulties: "乗り越えたこと", message: "メッセージ", studio: "スタジオへのひとこと", songTitle: "曲名", artist: "アーティスト名", socle: "木製スタンド", yes: "はい" }
    },
    it: {
      privacy: "Le tue risposte restano private",
      back: "Indietro", skip: "Salta", skipPhysical: "No grazie, continua senza", next: "Continua", stepWord: "Passo", ofWord: "di",
      ctaFinal: "Ordina la mia canzone",
      submitting: "Stiamo preparando il tuo ordine…", uploading: "Invio della tua foto…",
      stepNames: ["La persona", "Lo stile", "Il suo carattere", "I vostri ricordi", "Dal cuore", "Riepilogo", "Le tue opzioni", "Un ricordo da conservare"],
      ask: {"wife": "Come si chiama tua moglie?", "husband": "Come si chiama tuo marito?", "girlfriend": "Come si chiama la tua ragazza?", "boyfriend": "Come si chiama il tuo ragazzo?", "mother": "Come si chiama tua madre?", "father": "Come si chiama tuo padre?", "child": "Come si chiamano i tuoi figli?", "friend": "Come si chiama il tuo amico o la tua amica?", "self": "Come ti chiami?", "other": "Come si chiama questa persona?"},
      s2_titlePre: "Quale stile per ",
      s2_titlePost: "?",
      s4_titlePre: "I tuoi ricordi più belli con ",
      s4_titlePost: "",
      s5_titlePre: "Una parola dal cuore per ",
      s5_titlePost: "?",
      p6_titlePre: "Un ricordo da conservare per ",
      p6_titlePost: "?",
      ctaNoThanks: "No grazie",
      g_title: "Soddisfatti o rimborsati",
      g_body: "Modifiche illimitate finché la canzone non ti piace, oppure il rimborso completo.",
      o_delivPrefix: "Consegna il",
      t_secure: "Pagamento sicuro",
      t_refund: "Soddisfatti o rimborsati",
      t_free: "Modifiche gratuite",
      faqTitle: "Domande frequenti",
      faq: [["Come riceverò la mia canzone?", "La tua canzone arriva via email in MP3 di alta qualità, con un link privato per ascoltarla, scaricarla e condividerla."], ["Il pagamento è sicuro?", "Sì. Tutti i pagamenti passano da Shopify, con una crittografia di livello bancario. Non conserviamo mai i dati della tua carta."], ["Posso chiedere delle modifiche?", "Certo. Ritocchiamo la canzone gratis finché non ti piace."], ["Quanto tempo ci vuole?", "Circa 48 ore con la consegna standard. Con l'opzione 24 ore, la tua canzone è pronta già domani."]],
      r_title: "Controlla i dettagli della tua canzone",
      x_title: "Scopri alcune delle nostre canzoni",
      o_cardTitle: "Canzone per",
      o_cardEdit: "Modifica",
      o_express: "Consegna in 24 ore",
      o_expressMeta: "La stessa canzone, consegnata entro 24 ore",
      o_stream: "La tua canzone su Spotify e Apple Music",
      o_streamMeta: "Aggiungila alle tue playlist di tutti i giorni.",
      o_lyr: "Il suo testo, da conservare per sempre",
      o_lyrMeta: "Da stampare, con il suo nome e la copertina della canzone. Da conservare, regalare, incorniciare.",
      o_eyebrow: "Le tue opzioni",
      o_title: "Completa la tua canzone",
      o_sub: "Queste opzioni rendono il regalo ancora più completo.",
      o_paroles: "Il testo da stampare",
      o_parolesMeta: "Le parole della sua canzone, pronte da incorniciare",
      o_songLine: "La tua canzone personalizzata",
      o_optLabel: "Aggiungi alla tua canzone",
      o_uncheck: "Togli la spunta a ciò che non ti serve",
      r_eyebrow: "Quasi fatto",
      r_sub: "Rileggi le tue risposte. Puoi cambiare tutto con un clic.",
      r_edit: "Modifica",
      r_pour: "Per",
      r_occ: "Occasione",
      r_style: "Stile",
      r_voice: "Voce",
      r_qual: "Le sue qualità",
      r_mem: "I vostri ricordi",
      r_msg: "Dal cuore",
      r_vide: "Non indicato",
      r_photoTitle: "Aggiungi una foto",
      r_photoSub: "Apparirà sulla pagina della sua canzone.",
      r_photoBtn: "Scegli una foto",
      r_photoFree: "Gratis",
      r_photoDone: "Foto aggiunta",
      r_photoChange: "Cambia",
      r_photoConv: "Conversione della foto…",
      r_photoErrType: "Questo formato non è supportato. Prova con una foto JPG o PNG.",
      r_photoErrBig: "Questa foto è troppo pesante. Prova con una più leggera.",
      occLabel: "Per quale occasione?", occOtherPh: "Dicci l'occasione…",
      occasions: [
        { em: "🎂", label: "Compleanno" }, { em: "💞", label: "Anniversario" }, { em: "💍", label: "Matrimonio" }, { em: "👶", label: "Nascita" }, { em: "🎓", label: "Laurea" }, { em: "🌅", label: "Pensione" },
        { em: "🕊️", label: "In ricordo" }, { em: "❤️", label: "San Valentino" }, { em: "🌷", label: "Festa della mamma / del papà" }, { em: "🎄", label: "Natale" },
        { em: "✨", label: "Senza un motivo" }, { em: "✍️", label: "Altro" }
      ],
      diffLabel: "Un momento difficile che avete superato insieme?", diffPh: "Una malattia, la distanza, un lutto… quello che avete superato insieme.",
      s1_title: "Per chi è questa canzone?", s1_sub: "Raccontaci della persona che conta.",
      nameLabel: "Il suo nome", namePh: "Es. Francesca", s1_errRecipient: "Scegli per chi è la canzone.", s1_errName: "Scrivi il suo nome: lo canteremo nel ritornello.",
      s2_errStyle: "Scegli uno stile musicale.", s2_errVoice: "Scegli il tipo di voce.",
      recipients: [
        { key: "wife", em: "💍", label: "Mia moglie", rel: "wife", cat: "partner", g: "f" },
        { key: "husband", em: "🤵", label: "Mio marito", rel: "husband", cat: "partner", g: "m" },
        { key: "girlfriend", em: "💖", label: "La mia ragazza", rel: "girlfriend", cat: "partner", g: "f" },
        { key: "boyfriend", em: "💙", label: "Il mio ragazzo", rel: "boyfriend", cat: "partner", g: "m" },
        { key: "mother", em: "🌷", label: "Mia madre", rel: "mother", cat: "parent", g: "f" },
        { key: "father", em: "🌳", label: "Mio padre", rel: "father", cat: "parent", g: "m" },
        { key: "child", em: "👶", label: "I miei figli", rel: "child", cat: "child", g: "n" },
        { key: "friend", em: "🤝", label: "Un amico o un'amica", rel: "friend", cat: "other", g: "n" },
        { key: "self", em: "🎁", label: "Per me", rel: "myself", cat: "other", g: "n" },
        { key: "other", em: "✨", label: "Una persona speciale", rel: "someone dear", cat: "other", g: "n" }
      ],
      s2_eyebrow: "L'atmosfera", s2_title: "Quale stile per la canzone?", s2_sub: "Scegli lo stile più adatto alla vostra storia.",
      topTag: "Top",
      stylesPop: ["Pop italiano", "Ballata romantica", "Sorprendimi", "Cantautore", "Acustico", "Piano e voce", "Napoletana", "Rock italiano"],
      stylesExtra: ["Pop lirico", "Anni '60", "Rap italiano", "Indie italiano", "Matrimonio / Primo ballo", "Ninna nanna", "Altro"],
      moreStyles: "Altri stili ▾", lessStyles: "Meno stili ▴",
      voiceLabel: "Tipo di voce", voiceHint: "Ti consigliamo di scegliere il tuo stesso genere: così la canzone suona più personale.", voices: ["Voce femminile", "Voce maschile", "Indifferente"],
      s3_eyebrow: "Il suo carattere", s3_titlePre: "Cosa rende ", s3_titleName: "questa persona", s3_titlePost: " così speciale?", s3_sub: "Descrivi il suo carattere e le qualità che ami di più.",
      qualities: ["Premuroso/a", "Generoso/a", "Divertente", "Dolce", "Forte", "Gentile", "Appassionato/a", "Complice", "Coraggioso/a", "Spontaneo/a", "Leale", "Solare"],
      qmoreLabel: "Le sue qualità più belle", qmorePh: "La sua pazienza, il suo umorismo, come ti protegge, come c'è sempre quando conta… Raccontaci cosa rende unica questa persona.", facult: "facoltativo",
      s4_eyebrow: "I vostri momenti", s4_title: "I vostri ricordi più preziosi", memPh: "Come vi siete conosciuti, gli anni che contano, le battute che capite solo voi, i momenti che hanno fatto la vostra storia…", memHint: "Più dettagli ci dai (luoghi, date, soprannomi), più la canzone sarà emozionante.",
      memSubs: {
        partner: "Quali momenti con questa persona contano di più per te?",
        parent: "Quali momenti con questa persona contano di più per te?",
        child: "Quali momenti con questa persona contano di più per te?",
        other: "Quali momenti con questa persona contano di più per te?"
      },
      prompts: {
        partner: ["Come ci siamo conosciuti…", "Una risata insieme…", "Un momento che conta…"],
        parent: ["Un ricordo d'infanzia…", "Quello che mi ha insegnato…", "Un'abitudine che ti fa sorridere…"],
        child: ["Il giorno della nascita…", "Un momento solo vostro…", "Ciò che ti riempie d'orgoglio…"],
        other: ["Come vi siete conosciuti…", "Un ricordo speciale…", "Cosa vi unisce…"]
      },
      s5_eyebrow: "Il cuore", s5_title: "Una parola dal cuore?", s5_sub: "Un messaggio personale che vorresti sentire nella canzone.",
      msgPH: { f: "Voglio che lei sappia che…", m: "Voglio che lui sappia che…", n: "Quello che vorrei dire è…" },
      studioLabel: "Un'ultima parola per lo studio?", studioPh: "Un desiderio, qualcosa da evitare, un dettaglio che conta…",
      p6_eyebrow: "Il regalo", p6_title: "Un ricordo da conservare?", p6_sub: "Una targa o una calamita con il codice QR della tua canzone, consegnata a casa tua.",
      p6_plaque: "Targa QR", p6_magnet: "Calamita QR", p6_socle: "Aggiungi la base in legno",
      p6_titleLabel: "Titolo della canzone", p6_titlePh: "Il titolo da incidere", p6_titleMax: "Massimo 40 caratteri",
      p6_artistLabel: "Artista", p6_artistPh: "Una firma, un occhiolino, un soprannome", p6_artistMax: "Massimo 30 caratteri",
      p6_photoLabel: "Foto di copertina", p6_photoBtn: "Scegli una foto", p6_photoHelp: "JPG, PNG, WEBP o foto da iPhone · max 20 MB",
      p6_errFields: "Scrivi il titolo e l'artista da incidere.", p6_errPhoto: "Per questo prodotto serve una foto.",
      p6_errPhotoBig: "Foto troppo grande (max 20 MB).", p6_errPhotoType: "Formato non supportato. Usa JPG, PNG o WEBP.", p6_converting: "Conversione della foto iPhone…",
      p7_eyebrow: "Ultimo passo", p7_title: "Consegna e ascolto", p7_sub: "Scegli come e quando ricevere la tua canzone.",
      p7_deliveryLabel: "Consegna della canzone", p7_std: "Standard", p7_stdMeta: "Entro 48 ore · via email", p7_stdPrice: "Incluso",
      p7_express: "Express", p7_expressMeta: "Entro 24 ore · con priorità",
      p7_diffusionLabel: "Streaming", p7_streaming: "Streaming su Spotify e Apple Music", p7_streamingMeta: "La tua canzone su tutte le piattaforme",
      p7_sessions: "Prossime sessioni di registrazione",
      sessions: { delivery: "Consegna", reserved: "PRENOTATO", days: ["domenica","lunedì","martedì","mercoledì","giovedì","venerdì","sabato"], months: ["gennaio","febbraio","marzo","aprile","maggio","giugno","luglio","agosto","settembre","ottobre","novembre","dicembre"] },
      errGeneric: "Si è verificato un errore. Controlla la connessione e riprova.",
      props: { recipient: "Per chi", firstName: "Nome", style: "Stile musicale", voice: "Voce", occasion: "Occasione", qualities: "Qualità", memories: "Ricordi", difficulties: "Momenti difficili", message: "Messaggio", studio: "Nota per lo studio", songTitle: "Titolo della canzone", artist: "Artista", socle: "Base in legno", yes: "Sì" }
    },
    nl: {
      privacy: "Je antwoorden blijven privé",
      back: "Terug", skip: "Overslaan", skipPhysical: "Nee bedankt, verder zonder", next: "Verder", stepWord: "Stap", ofWord: "van",
      ctaFinal: "Bestel mijn lied",
      submitting: "Je bestelling wordt klaargezet…", uploading: "Je foto wordt verstuurd…",
      stepNames: ["Voor wie", "De stijl", "Persoonlijkheid", "Jullie herinneringen", "Uit het hart", "Overzicht", "Je opties", "Een aandenken"],
      ask: {"wife": "Hoe heet je vrouw?", "husband": "Hoe heet je man?", "girlfriend": "Hoe heet je vriendin?", "boyfriend": "Hoe heet je vriend?", "mother": "Hoe heet je moeder?", "father": "Hoe heet je vader?", "child": "Hoe heten je kinderen?", "friend": "Hoe heet je vriend of vriendin?", "self": "Wat is je voornaam?", "other": "Hoe heet deze persoon?"},
      s2_titlePre: "Welke stijl voor ",
      s2_titlePost: "?",
      s4_titlePre: "Je mooiste herinneringen met ",
      s4_titlePost: "",
      s5_titlePre: "Een woord uit het hart voor ",
      s5_titlePost: "?",
      p6_titlePre: "Een aandenken voor ",
      p6_titlePost: "?",
      ctaNoThanks: "Nee bedankt",
      g_title: "Niet goed, geld terug",
      g_body: "Onbeperkt aanpassen tot je het lied prachtig vindt, of je krijgt je geld volledig terug.",
      o_delivPrefix: "Geleverd op",
      t_secure: "Veilig betalen",
      t_refund: "Niet goed, geld terug",
      t_free: "Gratis aanpassingen",
      faqTitle: "Veelgestelde vragen",
      faq: [["Hoe ontvang ik mijn lied?", "Je lied komt per e-mail als MP3 van hoge kwaliteit, met een privélink om het te beluisteren, te downloaden en te delen."], ["Is betalen veilig?", "Ja. Alle betalingen lopen via Shopify, met versleuteling van bankniveau. We bewaren nooit je kaartgegevens."], ["Kan ik om aanpassingen vragen?", "Natuurlijk. We passen het lied gratis aan tot je er helemaal blij mee bent."], ["Hoe snel heb ik het?", "Ongeveer 48 uur met standaardlevering. Met de 24-uursoptie is je lied morgen al klaar."]],
      r_title: "Controleer de details van je lied",
      x_title: "Ontdek een paar van onze liedjes",
      o_cardTitle: "Lied voor",
      o_cardEdit: "Wijzigen",
      o_express: "Levering binnen 24 uur",
      o_expressMeta: "Hetzelfde lied, binnen 24 uur geleverd",
      o_stream: "Je lied op Spotify en Apple Music",
      o_streamMeta: "Zet het in je dagelijkse playlists.",
      o_lyr: "Bewaar de songtekst voor altijd",
      o_lyrMeta: "Om te printen, met de naam en de cover van het lied. Om te bewaren, te geven of in te lijsten.",
      o_eyebrow: "Je opties",
      o_title: "Maak je lied compleet",
      o_sub: "Met deze opties wordt het cadeau nog completer.",
      o_paroles: "Songtekst om te printen",
      o_parolesMeta: "De tekst van het lied, klaar om in te lijsten",
      o_songLine: "Je persoonlijke lied",
      o_optLabel: "Voeg toe aan je lied",
      o_uncheck: "Vink uit wat je niet nodig hebt",
      r_eyebrow: "Bijna klaar",
      r_sub: "Lees je antwoorden nog eens na. Alles pas je met één klik aan.",
      r_edit: "Wijzigen",
      r_pour: "Voor",
      r_occ: "Gelegenheid",
      r_style: "Stijl",
      r_voice: "Stem",
      r_qual: "Eigenschappen",
      r_mem: "Jullie herinneringen",
      r_msg: "Uit het hart",
      r_vide: "Niet ingevuld",
      r_photoTitle: "Voeg een foto toe",
      r_photoSub: "Die verschijnt op de pagina van het lied.",
      r_photoBtn: "Kies een foto",
      r_photoFree: "Gratis",
      r_photoDone: "Foto toegevoegd",
      r_photoChange: "Wijzigen",
      r_photoConv: "Je foto wordt omgezet…",
      r_photoErrType: "Dit fotoformaat wordt niet ondersteund. Probeer een JPG of PNG.",
      r_photoErrBig: "Deze foto is te groot. Probeer een kleinere.",
      occLabel: "Voor welke gelegenheid?", occOtherPh: "Vertel ons de gelegenheid…",
      occasions: [
        { em: "🎂", label: "Verjaardag" }, { em: "💞", label: "Jubileum" }, { em: "💍", label: "Bruiloft" }, { em: "👶", label: "Geboorte" }, { em: "🌅", label: "Pensioen" },
        { em: "🕊️", label: "Ter nagedachtenis" }, { em: "❤️", label: "Valentijnsdag" }, { em: "🌷", label: "Moederdag / Vaderdag" }, { em: "🎁", label: "Sinterklaas" }, { em: "🎄", label: "Kerst" },
        { em: "✨", label: "Zomaar" }, { em: "✍️", label: "Andere gelegenheid" }
      ],
      diffLabel: "Een moeilijke tijd die jullie samen hebben doorstaan?", diffPh: "Een ziekte, afstand, een verlies… wat jullie samen hebben overwonnen.",
      s1_title: "Voor wie is dit lied?", s1_sub: "Vertel ons over die bijzondere persoon.",
      nameLabel: "Voornaam", namePh: "Bijv. Anouk", s1_errRecipient: "Kies voor wie het lied is.", s1_errName: "Vul de voornaam in: die wordt gezongen in het refrein.",
      s2_errStyle: "Kies een muziekstijl.", s2_errVoice: "Kies een stem.",
      recipients: [
        { key: "wife", em: "💍", label: "Mijn vrouw", rel: "wife", cat: "partner", g: "f" },
        { key: "husband", em: "🤵", label: "Mijn man", rel: "husband", cat: "partner", g: "m" },
        { key: "girlfriend", em: "💖", label: "Mijn vriendin", rel: "girlfriend", cat: "partner", g: "f" },
        { key: "boyfriend", em: "💙", label: "Mijn vriend", rel: "boyfriend", cat: "partner", g: "m" },
        { key: "mother", em: "🌷", label: "Mijn moeder", rel: "mother", cat: "parent", g: "f" },
        { key: "father", em: "🌳", label: "Mijn vader", rel: "father", cat: "parent", g: "m" },
        { key: "child", em: "👶", label: "Mijn kinderen", rel: "child", cat: "child", g: "n" },
        { key: "friend", em: "🤝", label: "Een goede vriend(in)", rel: "friend", cat: "other", g: "n" },
        { key: "self", em: "🎁", label: "Voor mezelf", rel: "myself", cat: "other", g: "n" },
        { key: "other", em: "✨", label: "Iemand bijzonders", rel: "someone dear", cat: "other", g: "n" }
      ],
      s2_eyebrow: "De sfeer", s2_title: "Welke stijl voor het lied?", s2_sub: "Kies de stijl die bij jullie verhaal past.",
      topTag: "Top",
      stylesPop: ["Nederlandstalige pop", "Ballad", "Verras me", "Levenslied", "Akoestisch", "Pianoballad", "Meezinger", "Nederrock"],
      stylesExtra: ["Nederhop", "Nederlandse soul", "Dancepop", "Carnaval", "Bruiloft / Openingsdans", "Kinderliedje", "Andere stijl"],
      moreStyles: "Meer stijlen ▾", lessStyles: "Minder stijlen ▴",
      voiceLabel: "Welke stem?", voiceHint: "We raden je aan je eigen gender te kiezen: dan voelt het lied persoonlijker.", voices: ["Zangeres", "Zanger", "Maakt niet uit"],
      s3_eyebrow: "Persoonlijkheid", s3_titlePre: "Wat maakt ", s3_titleName: "deze persoon", s3_titlePost: " zo bijzonder?", s3_sub: "Beschrijf het karakter en de eigenschappen waar je het meest van houdt.",
      qualities: ["Zorgzaam", "Gul", "Grappig", "Lief", "Sterk", "Vriendelijk", "Gepassioneerd", "Vertrouwd", "Dapper", "Spontaan", "Trouw", "Stralend"],
      qmoreLabel: "Mooiste eigenschappen", qmorePh: "Geduldig, wijs, grappig, beschermend, er altijd als het erop aankomt? Vertel wat deze persoon zo bijzonder maakt.", facult: "optioneel",
      s4_eyebrow: "Jullie momenten", s4_title: "Jullie mooiste herinneringen", memPh: "Hoe jullie elkaar leerden kennen, de jaren die ertoe deden, de grapjes die alleen jullie snappen, de momenten die jullie verhaal maakten…", memHint: "Hoe preciezer (plekken, data, bijnamen), hoe ontroerender het lied.",
      memSubs: {
        partner: "Welke momenten met deze persoon betekenen het meest voor je?",
        parent: "Welke momenten met deze persoon betekenen het meest voor je?",
        child: "Welke momenten met deze persoon betekenen het meest voor je?",
        other: "Welke momenten met deze persoon betekenen het meest voor je?"
      },
      prompts: {
        partner: ["Hoe we elkaar ontmoetten…", "Samen slap van het lachen…", "Een moment dat telt…"],
        parent: ["Een herinnering uit mijn jeugd…", "Wat hij of zij me leerde…", "Een gewoonte waar je om moet glimlachen…"],
        child: ["De dag van de geboorte…", "Een moment van jullie samen…", "Waar je trots op bent…"],
        other: ["Hoe jullie elkaar leerden kennen…", "Een moment om nooit te vergeten…", "Wat jullie verbindt…"]
      },
      s5_eyebrow: "Het hart", s5_title: "Een woord uit het hart?", s5_sub: "Een persoonlijke boodschap die je graag in het lied wilt horen.",
      msgPH: { f: "Ik wil dat ze weet dat…", m: "Ik wil dat hij weet dat…", n: "Wat ik graag wil zeggen is…" },
      studioLabel: "Nog een laatste woord voor de studio?", studioPh: "Een wens, iets om te vermijden, een detail dat telt…",
      p6_eyebrow: "Het cadeau", p6_title: "Een aandenken?", p6_sub: "Een bordje of een magneet met de QR-code van je lied, bij je thuisbezorgd.",
      p6_plaque: "QR-bordje", p6_magnet: "QR-magneet", p6_socle: "Houten standaard toevoegen",
      p6_titleLabel: "Titel van het lied", p6_titlePh: "De titel die je wilt laten graveren", p6_titleMax: "Maximaal 40 tekens",
      p6_artistLabel: "Artiest", p6_artistPh: "Een handtekening, een knipoog, een bijnaam", p6_artistMax: "Maximaal 30 tekens",
      p6_photoLabel: "Coverfoto", p6_photoBtn: "Kies een foto", p6_photoHelp: "JPG, PNG, WEBP of iPhone-foto · max. 20 MB",
      p6_errFields: "Vul de titel en de artiest in die gegraveerd moeten worden.", p6_errPhoto: "Voor dit product is een foto nodig.",
      p6_errPhotoBig: "Foto te groot (max. 20 MB).", p6_errPhotoType: "Formaat niet ondersteund. Gebruik JPG, PNG of WEBP.", p6_converting: "iPhone-foto wordt omgezet…",
      p7_eyebrow: "Laatste stap", p7_title: "Levering en luisteren", p7_sub: "Kies hoe en wanneer je je lied ontvangt.",
      p7_deliveryLabel: "Levering van het lied", p7_std: "Standaard", p7_stdMeta: "Binnen 48 uur · per e-mail", p7_stdPrice: "Inbegrepen",
      p7_express: "Express", p7_expressMeta: "Binnen 24 uur · met voorrang",
      p7_diffusionLabel: "Streaming", p7_streaming: "Streaming op Spotify en Apple Music", p7_streamingMeta: "Je lied op alle platforms",
      p7_sessions: "Komende opnamesessies",
      sessions: { delivery: "Levering op", reserved: "GERESERVEERD", days: ["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"], months: ["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"] },
      errGeneric: "Er ging iets mis. Controleer je verbinding en probeer het opnieuw.",
      props: { recipient: "Voor wie", firstName: "Voornaam", style: "Muziekstijl", voice: "Stem", occasion: "Gelegenheid", qualities: "Eigenschappen", memories: "Herinneringen", difficulties: "Moeilijke tijden", message: "Boodschap", studio: "Notitie voor de studio", songTitle: "Titel van het lied", artist: "Artiest", socle: "Houten standaard", yes: "Ja" }
    },
    sv: {
      privacy: "Dina svar stannar hos oss",
      back: "Tillbaka", skip: "Hoppa över", skipPhysical: "Nej tack, fortsätt utan", next: "Fortsätt", stepWord: "Steg", ofWord: "av",
      ctaFinal: "Beställ min låt",
      submitting: "Din beställning förbereds…", uploading: "Ditt foto laddas upp…",
      stepNames: ["Till vem", "Stilen", "Personligheten", "Era minnen", "Från hjärtat", "Sammanfattning", "Dina tillval", "En minnessak"],
      ask: {"wife": "Vad heter din fru?", "husband": "Vad heter din man?", "girlfriend": "Vad heter din flickvän?", "boyfriend": "Vad heter din pojkvän?", "mother": "Vad heter din mamma?", "father": "Vad heter din pappa?", "child": "Vad heter dina barn?", "friend": "Vad heter din vän?", "self": "Vad heter du?", "other": "Vad heter personen?"},
      s2_titlePre: "Vilken stil passar ",
      s2_titlePost: "?",
      s4_titlePre: "Dina finaste minnen med ",
      s4_titlePost: "",
      s5_titlePre: "Ett ord från hjärtat till ",
      s5_titlePost: "?",
      p6_titlePre: "En minnessak till ",
      p6_titlePost: "?",
      ctaNoThanks: "Nej tack",
      g_title: "Nöjd eller pengarna tillbaka",
      g_body: "Obegränsat med ändringar tills du tycker att låten är underbar, eller så får du alla pengar tillbaka.",
      o_delivPrefix: "Levereras",
      t_secure: "Säker betalning",
      t_refund: "Nöjd eller pengarna tillbaka",
      t_free: "Gratis ändringar",
      faqTitle: "Vanliga frågor",
      faq: [["Hur får jag min låt?", "Din låt kommer via mejl som MP3 i hög kvalitet, med en privat länk där du kan lyssna på den, ladda ner den och dela den."], ["Är betalningen säker?", "Ja. Alla betalningar går via Shopify, med kryptering på banknivå. Vi sparar aldrig dina kortuppgifter."], ["Kan jag be om ändringar?", "Självklart. Vi ändrar låten gratis tills du är helt nöjd."], ["Hur snabbt får jag den?", "Ungefär 48 timmar med standardleverans. Med 24-timmarsalternativet är din låt klar redan i morgon."]],
      r_title: "Kontrollera detaljerna för din låt",
      x_title: "Upptäck några av våra låtar",
      o_cardTitle: "Låt till",
      o_cardEdit: "Ändra",
      o_express: "Leverans inom 24 timmar",
      o_expressMeta: "Samma låt, levererad inom 24 timmar",
      o_stream: "Din låt på Spotify och Apple Music",
      o_streamMeta: "Lägg till den i dina vardagliga spellistor.",
      o_lyr: "Spara låttexten för alltid",
      o_lyrMeta: "Utskrivbar, med namnet och låtens omslag. Att spara, ge bort eller rama in.",
      o_eyebrow: "Dina tillval",
      o_title: "Gör din låt komplett",
      o_sub: "Med de här tillvalen blir presenten ännu mer komplett.",
      o_paroles: "Utskrivbar låttext",
      o_parolesMeta: "Låtens text, redo att ramas in",
      o_songLine: "Din personliga låt",
      o_optLabel: "Lägg till i din låt",
      o_uncheck: "Bocka ur det du inte behöver",
      r_eyebrow: "Nästan klart",
      r_sub: "Läs igenom dina svar en gång till. Allt kan ändras med ett klick.",
      r_edit: "Ändra",
      r_pour: "Till",
      r_occ: "Tillfälle",
      r_style: "Stil",
      r_voice: "Röst",
      r_qual: "Egenskaper",
      r_mem: "Era minnen",
      r_msg: "Från hjärtat",
      r_vide: "Inte ifyllt",
      r_photoTitle: "Lägg till ett foto",
      r_photoSub: "Det visas på låtens sida.",
      r_photoBtn: "Välj ett foto",
      r_photoFree: "Gratis",
      r_photoDone: "Foto tillagt",
      r_photoChange: "Ändra",
      r_photoConv: "Ditt foto konverteras…",
      r_photoErrType: "Det här bildformatet stöds inte. Prova en JPG eller PNG.",
      r_photoErrBig: "Fotot är för stort. Prova ett mindre.",
      occLabel: "Vilket tillfälle gäller det?", occOtherPh: "Berätta vilket tillfälle…",
      occasions: [
        { em: "🎂", label: "Födelsedag" }, { em: "💞", label: "Årsdag" }, { em: "💍", label: "Bröllop" }, { em: "👶", label: "Födsel" }, { em: "🌅", label: "Pensionering" },
        { em: "🕊️", label: "Till minne" }, { em: "❤️", label: "Alla hjärtans dag" }, { em: "🌷", label: "Mors dag / Fars dag" }, { em: "🎁", label: "Studenten" }, { em: "🎄", label: "Jul" },
        { em: "✨", label: "Bara för att" }, { em: "✍️", label: "Annat tillfälle" }
      ],
      diffLabel: "En svår tid som ni har gått igenom tillsammans?", diffPh: "En sjukdom, ett avstånd, en förlust… det ni har klarat tillsammans.",
      s1_title: "Vem är låten till?", s1_sub: "Berätta om den där speciella personen.",
      nameLabel: "Förnamn", namePh: "T.ex. Maja", s1_errRecipient: "Välj vem låten är till.", s1_errName: "Fyll i förnamnet: det sjungs i refrängen.",
      s2_errStyle: "Välj en musikstil.", s2_errVoice: "Välj en röst.",
      recipients: [
        { key: "wife", em: "💍", label: "Min fru", rel: "wife", cat: "partner", g: "f" },
        { key: "husband", em: "🤵", label: "Min man", rel: "husband", cat: "partner", g: "m" },
        { key: "girlfriend", em: "💖", label: "Min flickvän", rel: "girlfriend", cat: "partner", g: "f" },
        { key: "boyfriend", em: "💙", label: "Min pojkvän", rel: "boyfriend", cat: "partner", g: "m" },
        { key: "mother", em: "🌷", label: "Min mamma", rel: "mother", cat: "parent", g: "f" },
        { key: "father", em: "🌳", label: "Min pappa", rel: "father", cat: "parent", g: "m" },
        { key: "child", em: "👶", label: "Mina barn", rel: "child", cat: "child", g: "n" },
        { key: "friend", em: "🤝", label: "En god vän", rel: "friend", cat: "other", g: "n" },
        { key: "self", em: "🎁", label: "Till mig själv", rel: "myself", cat: "other", g: "n" },
        { key: "other", em: "✨", label: "Någon speciell", rel: "someone dear", cat: "other", g: "n" }
      ],
      s2_eyebrow: "Känslan", s2_title: "Vilken stil ska låten ha?", s2_sub: "Välj den stil som passar er berättelse.",
      topTag: "Topp",
      stylesPop: ["Svensk pop", "Ballad", "Överraska mig", "Visa", "Akustisk", "Pianoballad", "Schlager", "Allsång"],
      stylesExtra: ["Svensk hiphop", "Soul", "Dansband", "Svensk rock", "Bröllop / Brudvals", "Barnvisa", "Annan stil"],
      moreStyles: "Fler stilar ▾", lessStyles: "Färre stilar ▴",
      voiceLabel: "Vilken röst?", voiceHint: "Vi rekommenderar att du väljer ditt eget kön: då känns låten mer personlig.", voices: ["Sångerska", "Sångare", "Spelar ingen roll"],
      s3_eyebrow: "Personligheten", s3_titlePre: "Vad gör ", s3_titleName: "den här personen", s3_titlePost: " så speciell?", s3_sub: "Beskriv personligheten och de egenskaper du älskar mest.",
      qualities: ["Omtänksam", "Generös", "Rolig", "Kärleksfull", "Stark", "Snäll", "Passionerad", "Trygg", "Modig", "Spontan", "Trofast", "Strålande"],
      qmoreLabel: "Finaste egenskaperna", qmorePh: "Tålmodig, klok, rolig, beskyddande, alltid där när det gäller? Berätta vad som gör den här personen så speciell.", facult: "valfritt",
      s4_eyebrow: "Era stunder", s4_title: "Era finaste minnen", memPh: "Hur ni träffades, åren som betydde något, skämten som bara ni förstår, stunderna som blev er historia…", memHint: "Ju mer exakt (platser, datum, smeknamn), desto mer berörande blir låten.",
      memSubs: {
        partner: "Vilka stunder med den här personen betyder mest för dig?",
        parent: "Vilka stunder med den här personen betyder mest för dig?",
        child: "Vilka stunder med den här personen betyder mest för dig?",
        other: "Vilka stunder med den här personen betyder mest för dig?"
      },
      prompts: {
        partner: ["Hur vi träffades…", "När vi skrattade tills vi grät…", "En stund som betyder mycket…"],
        parent: ["Ett minne från min barndom…", "Något hon eller han lärde mig…", "En vana som får dig att le…"],
        child: ["Dagen då barnet föddes…", "En stund bara ni två…", "Det du är stolt över…"],
        other: ["Hur ni lärde känna varandra…", "En stund ni aldrig glömmer…", "Det som förenar er…"]
      },
      s5_eyebrow: "Hjärtat", s5_title: "Ett ord från hjärtat?", s5_sub: "Ett personligt budskap som du vill höra i låten.",
      msgPH: { f: "Jag vill att hon ska veta att…", m: "Jag vill att han ska veta att…", n: "Det jag vill säga är…" },
      studioLabel: "Ett sista ord till studion?", studioPh: "En önskan, något att undvika, en detalj som betyder något…",
      p6_eyebrow: "Presenten", p6_title: "En minnessak?", p6_sub: "En plakett eller en magnet med QR-koden till din låt, levererad hem till dig.",
      p6_plaque: "QR-plakett", p6_magnet: "QR-magnet", p6_socle: "Lägg till träfoten",
      p6_titleLabel: "Låtens titel", p6_titlePh: "Titeln du vill få graverad", p6_titleMax: "Högst 40 tecken",
      p6_artistLabel: "Artist", p6_artistPh: "En signatur, en blinkning, ett smeknamn", p6_artistMax: "Högst 30 tecken",
      p6_photoLabel: "Omslagsfoto", p6_photoBtn: "Välj ett foto", p6_photoHelp: "JPG, PNG, WEBP eller iPhone-foto · max 20 MB",
      p6_errFields: "Fyll i titeln och artisten som ska graveras.", p6_errPhoto: "Den här produkten kräver ett foto.",
      p6_errPhotoBig: "Fotot är för stort (max 20 MB).", p6_errPhotoType: "Formatet stöds inte. Använd JPG, PNG eller WEBP.", p6_converting: "iPhone-fotot konverteras…",
      p7_eyebrow: "Sista steget", p7_title: "Leverans och lyssning", p7_sub: "Välj hur och när du vill få din låt.",
      p7_deliveryLabel: "Leverans av låten", p7_std: "Standard", p7_stdMeta: "Inom 48 timmar · via mejl", p7_stdPrice: "Ingår",
      p7_express: "Express", p7_expressMeta: "Inom 24 timmar · med förtur",
      p7_diffusionLabel: "Streaming", p7_streaming: "Streaming på Spotify och Apple Music", p7_streamingMeta: "Din låt på alla plattformar",
      p7_sessions: "Kommande inspelningstillfällen",
      sessions: { delivery: "Leverans", reserved: "BOKAD", days: ["söndag","måndag","tisdag","onsdag","torsdag","fredag","lördag"], months: ["januari","februari","mars","april","maj","juni","juli","augusti","september","oktober","november","december"] },
      errGeneric: "Något gick fel. Kontrollera din anslutning och försök igen.",
      props: { recipient: "Till vem", firstName: "Förnamn", style: "Musikstil", voice: "Röst", occasion: "Tillfälle", qualities: "Egenskaper", memories: "Minnen", difficulties: "Svåra tider", message: "Budskap", studio: "Anteckning till studion", songTitle: "Låtens titel", artist: "Artist", socle: "Träfot", yes: "Ja" }
    },
    da: {
      privacy: "Dine svar forbliver private",
      back: "Tilbage", skip: "Spring over", skipPhysical: "Nej tak, fortsæt uden", next: "Fortsæt", stepWord: "Trin", ofWord: "af",
      ctaFinal: "Bestil min sang",
      submitting: "Din bestilling gøres klar…", uploading: "Dit billede sendes…",
      stepNames: ["Til hvem", "Stilen", "Personlighed", "Jeres minder", "Fra hjertet", "Overblik", "Dine tilvalg", "Et minde"],
      ask: {"wife": "Hvad hedder din kone?", "husband": "Hvad hedder din mand?", "girlfriend": "Hvad hedder din kæreste?", "boyfriend": "Hvad hedder din kæreste?", "mother": "Hvad hedder din mor?", "father": "Hvad hedder din far?", "child": "Hvad hedder dine børn?", "friend": "Hvad hedder din ven eller veninde?", "self": "Hvad er dit fornavn?", "other": "Hvad hedder personen?"},
      s2_titlePre: "Hvilken stil til ",
      s2_titlePost: "?",
      s4_titlePre: "Dine smukkeste minder med ",
      s4_titlePost: "",
      s5_titlePre: "Et ord fra hjertet til ",
      s5_titlePost: "?",
      p6_titlePre: "Et minde til ",
      p6_titlePost: "?",
      ctaNoThanks: "Nej tak",
      g_title: "Tilfreds eller pengene tilbage",
      g_body: "Ubegrænsede ændringer, indtil du elsker sangen, eller du får alle pengene tilbage.",
      o_delivPrefix: "Leveres den",
      t_secure: "Sikker betaling",
      t_refund: "Tilfreds eller pengene tilbage",
      t_free: "Gratis ændringer",
      faqTitle: "Ofte stillede spørgsmål",
      faq: [["Hvordan modtager jeg min sang?", "Din sang kommer på mail som MP3 i høj kvalitet, med et privat link, hvor du kan lytte til den, downloade den og dele den."], ["Er betalingen sikker?", "Ja. Alle betalinger går gennem Shopify med kryptering på bankniveau. Vi gemmer aldrig dine kortoplysninger."], ["Kan jeg bede om ændringer?", "Selvfølgelig. Vi retter sangen gratis, indtil du er helt glad for den."], ["Hvor hurtigt får jeg den?", "Cirka 48 timer med standardlevering. Med 24-timersmuligheden er din sang klar allerede i morgen."]],
      r_title: "Tjek detaljerne for din sang",
      x_title: "Hør nogle af vores sange",
      o_cardTitle: "Sang til",
      o_cardEdit: "Ret",
      o_express: "Levering inden for 24 timer",
      o_expressMeta: "Samme sang, leveret inden for 24 timer",
      o_stream: "Din sang på Spotify og Apple Music",
      o_streamMeta: "Sæt den på dine daglige playlister.",
      o_lyr: "Gem sangteksten for altid",
      o_lyrMeta: "Til at printe, med navnet og sangens cover. Gem den, giv den væk, eller sæt den i ramme.",
      o_eyebrow: "Dine tilvalg",
      o_title: "Gør din sang komplet",
      o_sub: "Med disse tilvalg bliver gaven endnu mere komplet.",
      o_paroles: "Sangtekst til at printe",
      o_parolesMeta: "Sangens tekst, klar til at blive sat i ramme",
      o_songLine: "Din personlige sang",
      o_optLabel: "Føj til din sang",
      o_uncheck: "Fjern fluebenet ved det, du ikke har brug for",
      r_eyebrow: "Næsten færdig",
      r_sub: "Læs dine svar igennem en sidste gang. Du kan rette alt med ét klik.",
      r_edit: "Ret",
      r_pour: "Til",
      r_occ: "Anledning",
      r_style: "Stil",
      r_voice: "Stemme",
      r_qual: "Egenskaber",
      r_mem: "Jeres minder",
      r_msg: "Fra hjertet",
      r_vide: "Ikke udfyldt",
      r_photoTitle: "Tilføj et billede",
      r_photoSub: "Det vises på sangens side.",
      r_photoBtn: "Vælg et billede",
      r_photoFree: "Gratis",
      r_photoDone: "Billede tilføjet",
      r_photoChange: "Skift",
      r_photoConv: "Dit billede konverteres…",
      r_photoErrType: "Dette billedformat understøttes ikke. Prøv en JPG eller PNG.",
      r_photoErrBig: "Billedet er for stort. Prøv et mindre.",
      occLabel: "Til hvilken anledning?", occOtherPh: "Fortæl os om anledningen…",
      occasions: [
        { em: "🎂", label: "Fødselsdag" }, { em: "💞", label: "Årsdag" }, { em: "💍", label: "Bryllup" }, { em: "👶", label: "Fødsel" }, { em: "🌅", label: "Pensionering" },
        { em: "🕊️", label: "Til minde" }, { em: "❤️", label: "Valentinsdag" }, { em: "🌷", label: "Mors dag / Fars dag" }, { em: "🎁", label: "Konfirmation" }, { em: "🎄", label: "Jul" },
        { em: "✨", label: "Bare fordi" }, { em: "✍️", label: "Anden anledning" }
      ],
      diffLabel: "En svær tid, I er kommet igennem sammen?", diffPh: "En sygdom, afstand, et tab… det, I har overvundet sammen.",
      s1_title: "Hvem er sangen til?", s1_sub: "Fortæl os om den helt særlige person.",
      nameLabel: "Fornavn", namePh: "F.eks. Freja", s1_errRecipient: "Vælg, hvem sangen er til.", s1_errName: "Skriv fornavnet: det bliver sunget i omkvædet.",
      s2_errStyle: "Vælg en musikstil.", s2_errVoice: "Vælg en stemme.",
      recipients: [
        { key: "wife", em: "💍", label: "Min kone", rel: "wife", cat: "partner", g: "f" },
        { key: "husband", em: "🤵", label: "Min mand", rel: "husband", cat: "partner", g: "m" },
        { key: "girlfriend", em: "💖", label: "Min kæreste (hun)", rel: "girlfriend", cat: "partner", g: "f" },
        { key: "boyfriend", em: "💙", label: "Min kæreste (han)", rel: "boyfriend", cat: "partner", g: "m" },
        { key: "mother", em: "🌷", label: "Min mor", rel: "mother", cat: "parent", g: "f" },
        { key: "father", em: "🌳", label: "Min far", rel: "father", cat: "parent", g: "m" },
        { key: "child", em: "👶", label: "Mine børn", rel: "child", cat: "child", g: "n" },
        { key: "friend", em: "🤝", label: "En god ven / veninde", rel: "friend", cat: "other", g: "n" },
        { key: "self", em: "🎁", label: "Til mig selv", rel: "myself", cat: "other", g: "n" },
        { key: "other", em: "✨", label: "En helt særlig person", rel: "someone dear", cat: "other", g: "n" }
      ],
      s2_eyebrow: "Stemningen", s2_title: "Hvilken stil til sangen?", s2_sub: "Vælg den stil, der passer til jeres historie.",
      topTag: "Top",
      stylesPop: ["Dansk pop", "Ballade", "Overrask mig", "Visesang", "Akustisk", "Klaverballade", "Fællessang", "Dansk rock"],
      stylesExtra: ["Dansk rap", "Soul", "Dancepop", "Dansktop", "Bryllup / Brudevals", "Børnesang", "Anden stil"],
      moreStyles: "Flere stilarter ▾", lessStyles: "Færre stilarter ▴",
      voiceLabel: "Hvilken stemme?", voiceHint: "Vi anbefaler, at du vælger dit eget køn: så føles sangen mere personlig.", voices: ["Kvindestemme", "Mandestemme", "Ingen præference"],
      s3_eyebrow: "Personlighed", s3_titlePre: "Hvad gør ", s3_titleName: "denne person", s3_titlePost: " så særlig?", s3_sub: "Beskriv personligheden og de egenskaber, du holder mest af.",
      qualities: ["Omsorgsfuld", "Gavmild", "Sjov", "Sød", "Stærk", "Venlig", "Passioneret", "Tryg", "Modig", "Spontan", "Loyal", "Strålende"],
      qmoreLabel: "Smukkeste egenskaber", qmorePh: "Tålmodig, klog, sjov, beskyttende, altid der, når det gælder? Fortæl, hvad der gør personen så særlig.", facult: "valgfrit",
      s4_eyebrow: "Jeres øjeblikke", s4_title: "Jeres smukkeste minder", memPh: "Hvordan I mødte hinanden, de år der betød noget, de jokes kun I forstår, de øjeblikke der skabte jeres historie…", memHint: "Jo mere præcis du er (steder, datoer, kælenavne), jo mere rørende bliver sangen.",
      memSubs: {
        partner: "Hvilke øjeblikke med denne person betyder mest for dig?",
        parent: "Hvilke øjeblikke med denne person betyder mest for dig?",
        child: "Hvilke øjeblikke med denne person betyder mest for dig?",
        other: "Hvilke øjeblikke med denne person betyder mest for dig?"
      },
      prompts: {
        partner: ["Hvordan vi mødte hinanden…", "Da vi grinede, til vi græd…", "Et øjeblik, der betyder noget…"],
        parent: ["Et minde fra min barndom…", "Det, han eller hun lærte mig…", "En vane, der får dig til at smile…"],
        child: ["Dagen, barnet kom til verden…", "Et øjeblik bare for jer to…", "Det, du er stolt af…"],
        other: ["Hvordan I lærte hinanden at kende…", "Et øjeblik, I aldrig glemmer…", "Det, der binder jer sammen…"]
      },
      s5_eyebrow: "Hjertet", s5_title: "Et ord fra hjertet?", s5_sub: "En personlig besked, du gerne vil høre i sangen.",
      msgPH: { f: "Jeg vil have, at hun ved, at…", m: "Jeg vil have, at han ved, at…", n: "Det, jeg gerne vil sige, er…" },
      studioLabel: "Et sidste ord til studiet?", studioPh: "Et ønske, noget vi skal undgå, en detalje der betyder noget…",
      p6_eyebrow: "Gaven", p6_title: "Et minde?", p6_sub: "En plade eller en magnet med QR-koden til din sang, leveret til døren.",
      p6_plaque: "QR-plade", p6_magnet: "QR-magnet", p6_socle: "Tilføj træfod",
      p6_titleLabel: "Sangens titel", p6_titlePh: "Titlen, der skal stå på den", p6_titleMax: "Højst 40 tegn",
      p6_artistLabel: "Kunstner", p6_artistPh: "En signatur, et glimt i øjet, et kælenavn", p6_artistMax: "Højst 30 tegn",
      p6_photoLabel: "Coverbillede", p6_photoBtn: "Vælg et billede", p6_photoHelp: "JPG, PNG, WEBP eller iPhone-billede · maks. 20 MB",
      p6_errFields: "Udfyld titlen og kunstneren, der skal trykkes.", p6_errPhoto: "Dette produkt kræver et billede.",
      p6_errPhotoBig: "Billedet er for stort (maks. 20 MB).", p6_errPhotoType: "Formatet understøttes ikke. Brug JPG, PNG eller WEBP.", p6_converting: "iPhone-billedet konverteres…",
      p7_eyebrow: "Sidste trin", p7_title: "Levering og lytning", p7_sub: "Vælg, hvordan og hvornår du modtager din sang.",
      p7_deliveryLabel: "Levering af sangen", p7_std: "Standard", p7_stdMeta: "Inden for 48 timer · på mail", p7_stdPrice: "Inkluderet",
      p7_express: "Ekspres", p7_expressMeta: "Inden for 24 timer · med prioritet",
      p7_diffusionLabel: "Streaming", p7_streaming: "Streaming på Spotify og Apple Music", p7_streamingMeta: "Din sang på alle platforme",
      p7_sessions: "Kommende indspilninger",
      sessions: { delivery: "Levering den", reserved: "RESERVERET", days: ["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"], months: ["januar","februar","marts","april","maj","juni","juli","august","september","oktober","november","december"] },
      errGeneric: "Noget gik galt. Tjek din forbindelse, og prøv igen.",
      props: { recipient: "Til hvem", firstName: "Fornavn", style: "Musikstil", voice: "Stemme", occasion: "Anledning", qualities: "Egenskaber", memories: "Minder", difficulties: "Svære tider", message: "Besked", studio: "Note til studiet", songTitle: "Sangens titel", artist: "Kunstner", socle: "Træfod", yes: "Ja" }
    },
    nb: {
      privacy: "Svarene dine holdes private",
      back: "Tilbake", skip: "Hopp over", skipPhysical: "Nei takk, fortsett uten", next: "Fortsett", stepWord: "Steg", ofWord: "av",
      ctaFinal: "Bestill sangen min",
      submitting: "Bestillingen din gjøres klar…", uploading: "Bildet ditt sendes…",
      stepNames: ["Mottakeren", "Stilen", "Personligheten", "Minnene deres", "Fra hjertet", "Oversikt", "Tilleggene dine", "En minnegave"],
      ask: {"wife": "Hva heter kona di?", "husband": "Hva heter mannen din?", "girlfriend": "Hva heter kjæresten din?", "boyfriend": "Hva heter kjæresten din?", "mother": "Hva heter moren din?", "father": "Hva heter faren din?", "child": "Hva heter barna dine?", "friend": "Hva heter vennen din?", "self": "Hva er fornavnet ditt?", "other": "Hva heter denne personen?"},
      s2_titlePre: "Hvilken stil passer til ",
      s2_titlePost: "?",
      s4_titlePre: "De fineste minnene dine med ",
      s4_titlePost: "",
      s5_titlePre: "Et ord fra hjertet til ",
      s5_titlePost: "?",
      p6_titlePre: "En minnegave til ",
      p6_titlePost: "?",
      ctaNoThanks: "Nei takk",
      g_title: "Fornøyd eller pengene tilbake",
      g_body: "Ubegrensede endringer til du elsker sangen, ellers får du alle pengene tilbake.",
      o_delivPrefix: "Leveres",
      t_secure: "Sikker betaling",
      t_refund: "Fornøyd eller pengene tilbake",
      t_free: "Gratis endringer",
      faqTitle: "Ofte stilte spørsmål",
      faq: [["Hvordan får jeg sangen min?", "Sangen din kommer på e-post som MP3 i høy kvalitet, med en privat lenke der du kan lytte til den, laste den ned og dele den."], ["Er betalingen trygg?", "Ja. Alle betalinger går via Shopify, med kryptering på banknivå. Vi lagrer aldri kortopplysningene dine."], ["Kan jeg be om endringer?", "Selvfølgelig. Vi endrer sangen gratis til du er helt fornøyd."], ["Hvor fort får jeg den?", "Omtrent 48 timer med standardlevering. Med 24-timersvalget er sangen din klar allerede i morgen."]],
      r_title: "Sjekk detaljene for sangen din",
      x_title: "Hør noen av sangene våre",
      o_cardTitle: "Sang til",
      o_cardEdit: "Endre",
      o_express: "Levering innen 24 timer",
      o_expressMeta: "Samme sang, levert innen 24 timer",
      o_stream: "Sangen din på Spotify og Apple Music",
      o_streamMeta: "Legg den til i spillelistene du hører på hver dag.",
      o_lyr: "Ta vare på sangteksten for alltid",
      o_lyrMeta: "Til å skrive ut, med navnet og coveret til sangen. Til å ta vare på, gi bort eller ramme inn.",
      o_eyebrow: "Tilleggene dine",
      o_title: "Gjør sangen din komplett",
      o_sub: "Med disse tilleggene blir gaven enda finere.",
      o_paroles: "Sangtekst til utskrift",
      o_parolesMeta: "Teksten til sangen, klar til å rammes inn",
      o_songLine: "Den personlige sangen din",
      o_optLabel: "Legg til i sangen din",
      o_uncheck: "Fjern haken for det du ikke trenger",
      r_eyebrow: "Nesten ferdig",
      r_sub: "Les gjennom svarene dine en gang til. Du kan endre alt med ett klikk.",
      r_edit: "Endre",
      r_pour: "Til",
      r_occ: "Anledning",
      r_style: "Stil",
      r_voice: "Stemme",
      r_qual: "Egenskaper",
      r_mem: "Minnene deres",
      r_msg: "Fra hjertet",
      r_vide: "Ikke fylt ut",
      r_photoTitle: "Legg til et bilde",
      r_photoSub: "Det vises på siden til sangen.",
      r_photoBtn: "Velg et bilde",
      r_photoFree: "Gratis",
      r_photoDone: "Bildet er lagt til",
      r_photoChange: "Endre",
      r_photoConv: "Bildet ditt konverteres…",
      r_photoErrType: "Dette bildeformatet støttes ikke. Prøv JPG eller PNG.",
      r_photoErrBig: "Dette bildet er for stort. Prøv et mindre.",
      occLabel: "Hvilken anledning?", occOtherPh: "Fortell oss om anledningen…",
      occasions: [
        { em: "🎂", label: "Bursdag" }, { em: "💞", label: "Jubileum" }, { em: "💍", label: "Bryllup" }, { em: "👶", label: "Fødsel" }, { em: "🌅", label: "Pensjonering" },
        { em: "🕊️", label: "Til minne" }, { em: "❤️", label: "Valentinsdag" }, { em: "🌷", label: "Morsdag / Farsdag" }, { em: "🎁", label: "Konfirmasjon" }, { em: "🎄", label: "Jul" },
        { em: "✨", label: "Bare fordi" }, { em: "✍️", label: "Annen anledning" }
      ],
      diffLabel: "En vanskelig tid dere har kommet gjennom sammen?", diffPh: "En sykdom, avstand, et tap… det dere har klart sammen.",
      s1_title: "Hvem er sangen til?", s1_sub: "Fortell oss om den spesielle personen.",
      nameLabel: "Fornavn", namePh: "F.eks. Nora", s1_errRecipient: "Velg hvem sangen er til.", s1_errName: "Skriv inn fornavnet: det blir sunget i refrenget.",
      s2_errStyle: "Velg en musikkstil.", s2_errVoice: "Velg en stemme.",
      recipients: [
        { key: "wife", em: "💍", label: "Kona mi", rel: "wife", cat: "partner", g: "f" },
        { key: "husband", em: "🤵", label: "Mannen min", rel: "husband", cat: "partner", g: "m" },
        { key: "girlfriend", em: "💖", label: "Kjæresten min (hun)", rel: "girlfriend", cat: "partner", g: "f" },
        { key: "boyfriend", em: "💙", label: "Kjæresten min (han)", rel: "boyfriend", cat: "partner", g: "m" },
        { key: "mother", em: "🌷", label: "Moren min", rel: "mother", cat: "parent", g: "f" },
        { key: "father", em: "🌳", label: "Faren min", rel: "father", cat: "parent", g: "m" },
        { key: "child", em: "👶", label: "Barna mine", rel: "child", cat: "child", g: "n" },
        { key: "friend", em: "🤝", label: "En god venn", rel: "friend", cat: "other", g: "n" },
        { key: "self", em: "🎁", label: "Til meg selv", rel: "myself", cat: "other", g: "n" },
        { key: "other", em: "✨", label: "En spesiell person", rel: "someone dear", cat: "other", g: "n" }
      ],
      s2_eyebrow: "Stemningen", s2_title: "Hvilken stil skal sangen ha?", s2_sub: "Velg stilen som passer til historien deres.",
      topTag: "Topp",
      stylesPop: ["Norsk pop", "Ballade", "Overrask meg", "Visesang", "Akustisk", "Pianoballade", "Allsang", "Norsk rock"],
      stylesExtra: ["Norsk hiphop", "Soul", "Dansepop", "Danseband", "Bryllup / Brudevals", "Barnesang", "Annen stil"],
      moreStyles: "Flere stiler ▾", lessStyles: "Færre stiler ▴",
      voiceLabel: "Hvilken stemme?", voiceHint: "Vi anbefaler at du velger en stemme av ditt eget kjønn: da føles sangen mer personlig.", voices: ["Kvinnestemme", "Mannsstemme", "Samme for meg"],
      s3_eyebrow: "Personlighet", s3_titlePre: "Hva gjør ", s3_titleName: "denne personen", s3_titlePost: " så spesiell?", s3_sub: "Beskriv personligheten og egenskapene du er mest glad i.",
      qualities: ["Omsorgsfull", "Raus", "Morsom", "Kjærlig", "Sterk", "Vennlig", "Lidenskapelig", "Trygg", "Modig", "Spontan", "Lojal", "Strålende"],
      qmoreLabel: "De fineste egenskapene", qmorePh: "Tålmodig, klok, morsom, beskyttende, alltid der når det gjelder? Fortell hva som gjør denne personen så spesiell.", facult: "valgfritt",
      s4_eyebrow: "Øyeblikkene deres", s4_title: "De fineste minnene deres", memPh: "Hvordan dere møttes, årene som betydde noe, spøkene bare dere skjønner, øyeblikkene som ble historien deres…", memHint: "Jo mer presis du er (steder, datoer, kallenavn), jo mer rørende blir sangen.",
      memSubs: {
        partner: "Hvilke øyeblikk med denne personen betyr mest for deg?",
        parent: "Hvilke øyeblikk med denne personen betyr mest for deg?",
        child: "Hvilke øyeblikk med denne personen betyr mest for deg?",
        other: "Hvilke øyeblikk med denne personen betyr mest for deg?"
      },
      prompts: {
        partner: ["Hvordan vi møttes…", "Da vi lo til vi gråt…", "Et øyeblikk som betyr noe…"],
        parent: ["Et minne fra barndommen…", "Det hun eller han lærte meg…", "En vane som får deg til å smile…"],
        child: ["Dagen barnet ble født…", "Et øyeblikk bare for dere to…", "Det du er stolt av…"],
        other: ["Hvordan dere ble kjent…", "Et øyeblikk du aldri glemmer…", "Det som binder dere sammen…"]
      },
      s5_eyebrow: "Hjertet", s5_title: "Et ord fra hjertet?", s5_sub: "En personlig hilsen du gjerne vil høre i sangen.",
      msgPH: { f: "Jeg vil at hun skal vite at…", m: "Jeg vil at han skal vite at…", n: "Det jeg gjerne vil si, er…" },
      studioLabel: "Et siste ord til studioet?", studioPh: "Et ønske, noe vi bør unngå, en detalj som betyr noe…",
      p6_eyebrow: "Gaven", p6_title: "En minnegave?", p6_sub: "En plakett eller en magnet med QR-koden til sangen din, levert hjem til deg.",
      p6_plaque: "QR-plakett", p6_magnet: "QR-magnet", p6_socle: "Legg til trestativ",
      p6_titleLabel: "Tittel på sangen", p6_titlePh: "Tittelen du vil ha gravert", p6_titleMax: "Maks 40 tegn",
      p6_artistLabel: "Artist", p6_artistPh: "En signatur, et lite nikk, et kallenavn", p6_artistMax: "Maks 30 tegn",
      p6_photoLabel: "Coverbilde", p6_photoBtn: "Velg et bilde", p6_photoHelp: "JPG, PNG, WEBP eller iPhone-bilde · maks 20 MB",
      p6_errFields: "Fyll inn tittelen og artisten som skal graveres.", p6_errPhoto: "Dette produktet trenger et bilde.",
      p6_errPhotoBig: "Bildet er for stort (maks 20 MB).", p6_errPhotoType: "Formatet støttes ikke. Bruk JPG, PNG eller WEBP.", p6_converting: "iPhone-bildet konverteres…",
      p7_eyebrow: "Siste steg", p7_title: "Levering og lytting", p7_sub: "Velg hvordan og når du får sangen din.",
      p7_deliveryLabel: "Levering av sangen", p7_std: "Standard", p7_stdMeta: "Innen 48 timer · på e-post", p7_stdPrice: "Inkludert",
      p7_express: "Ekspress", p7_expressMeta: "Innen 24 timer · med prioritet",
      p7_diffusionLabel: "Strømming", p7_streaming: "Strømming på Spotify og Apple Music", p7_streamingMeta: "Sangen din på alle plattformer",
      p7_sessions: "Kommende innspillingsøkter",
      sessions: { delivery: "Levering", reserved: "RESERVERT", days: ["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"], months: ["januar","februar","mars","april","mai","juni","juli","august","september","oktober","november","desember"] },
      errGeneric: "Noe gikk galt. Sjekk tilkoblingen din og prøv igjen.",
      props: { recipient: "Til hvem", firstName: "Fornavn", style: "Musikkstil", voice: "Stemme", occasion: "Anledning", qualities: "Egenskaper", memories: "Minner", difficulties: "Vanskelige tider", message: "Hilsen", studio: "Notat til studioet", songTitle: "Tittel på sangen", artist: "Artist", socle: "Trestativ", yes: "Ja" }
    },
    pt: {
      privacy: "As suas respostas são confidenciais",
      back: "Voltar", skip: "Saltar", skipPhysical: "Agora não, continuar sem", next: "Continuar", stepWord: "Passo", ofWord: "de",
      ctaFinal: "Encomendar a minha canção",
      submitting: "A preparar a sua encomenda…", uploading: "A enviar a sua foto…",
      stepNames: ["Para quem", "O estilo", "Personalidade", "As vossas memórias", "Do coração", "Resumo", "As suas opções", "Uma lembrança"],
      ask: {"wife": "Como se chama a sua mulher?", "husband": "Como se chama o seu marido?", "girlfriend": "Como se chama a sua namorada?", "boyfriend": "Como se chama o seu namorado?", "mother": "Como se chama a sua mãe?", "father": "Como se chama o seu pai?", "child": "Como se chamam os seus filhos?", "friend": "Como se chama o seu amigo ou a sua amiga?", "self": "Qual é o seu nome?", "other": "Como se chama essa pessoa?"},
      s2_titlePre: "Que estilo para ",
      s2_titlePost: "?",
      s4_titlePre: "As melhores memórias com ",
      s4_titlePost: "",
      s5_titlePre: "Uma palavra do coração para ",
      s5_titlePost: "?",
      p6_titlePre: "Uma lembrança para ",
      p6_titlePost: "?",
      ctaNoThanks: "Agora não",
      g_title: "Garantia de reembolso",
      g_body: "Alterações ilimitadas até adorar a canção, ou devolvemos-lhe a totalidade do valor pago.",
      o_delivPrefix: "Entrega prevista:",
      t_secure: "Pagamento seguro",
      t_refund: "Garantia de reembolso",
      t_free: "Alterações gratuitas",
      faqTitle: "Perguntas frequentes",
      faq: [["Como vou receber a minha canção?", "A sua canção chega por e-mail em MP3 de alta qualidade, com um link privado para a ouvir, descarregar e partilhar."], ["O pagamento é seguro?", "Sim. Todos os pagamentos passam pela Shopify, com encriptação de nível bancário. Nunca guardamos os dados do seu cartão."], ["Posso pedir alterações?", "Claro. Ajustamos a canção gratuitamente até ficar exatamente como deseja."], ["Quanto tempo demora?", "Cerca de 48 horas com a entrega normal. Com a opção de 24 horas, a sua canção fica pronta já amanhã."]],
      r_title: "Confirme os detalhes da sua canção",
      x_title: "Descubra algumas das nossas canções",
      o_cardTitle: "Canção para",
      o_cardEdit: "Alterar",
      o_express: "Entrega em 24 horas",
      o_expressMeta: "A mesma canção, entregue em 24 horas",
      o_stream: "A sua canção no Spotify e no Apple Music",
      o_streamMeta: "Junte-a às suas playlists do dia a dia.",
      o_lyr: "Guarde a letra para sempre",
      o_lyrMeta: "Para imprimir, com o nome e a capa da canção. Para guardar, oferecer ou emoldurar.",
      o_eyebrow: "As suas opções",
      o_title: "Complete a sua canção",
      o_sub: "Com estas opções, o presente fica ainda mais completo.",
      o_paroles: "Letra para imprimir",
      o_parolesMeta: "A letra da canção, pronta a emoldurar",
      o_songLine: "A sua canção personalizada",
      o_optLabel: "Adicionar à sua canção",
      o_uncheck: "Desmarque o que não precisar",
      r_eyebrow: "Quase pronto",
      r_sub: "Releia as suas respostas. Pode alterar tudo com um clique.",
      r_edit: "Alterar",
      r_pour: "Para",
      r_occ: "Ocasião",
      r_style: "Estilo",
      r_voice: "Voz",
      r_qual: "Qualidades",
      r_mem: "As vossas memórias",
      r_msg: "Do coração",
      r_vide: "Não preenchido",
      r_photoTitle: "Adicione uma foto",
      r_photoSub: "Vai aparecer na página da canção.",
      r_photoBtn: "Escolher uma foto",
      r_photoFree: "Grátis",
      r_photoDone: "Foto adicionada",
      r_photoChange: "Alterar",
      r_photoConv: "A converter a sua foto…",
      r_photoErrType: "Este formato de foto não é suportado. Experimente JPG ou PNG.",
      r_photoErrBig: "Esta foto é demasiado grande. Experimente uma mais pequena.",
      occLabel: "Qual é a ocasião?", occOtherPh: "Diga-nos qual é a ocasião…",
      occasions: [
        { em: "🎂", label: "Aniversário" }, { em: "💞", label: "Aniversário de casamento" }, { em: "💍", label: "Casamento" }, { em: "👶", label: "Nascimento" }, { em: "🌅", label: "Reforma" },
        { em: "🕊️", label: "Em memória" }, { em: "❤️", label: "Dia dos Namorados" }, { em: "🌷", label: "Dia da Mãe / Dia do Pai" }, { em: "🎁", label: "Batizado" }, { em: "🎄", label: "Natal" },
        { em: "✨", label: "Só porque sim" }, { em: "✍️", label: "Outra ocasião" }
      ],
      diffLabel: "Um momento difícil que passaram juntos?", diffPh: "Uma doença, a distância, uma perda… aquilo que superaram juntos.",
      s1_title: "Para quem é esta canção?", s1_sub: "Fale-nos dessa pessoa especial.",
      nameLabel: "Nome", namePh: "Ex.: Inês", s1_errRecipient: "Escolha para quem é a canção.", s1_errName: "Indique o nome: vai ser cantado no refrão.",
      s2_errStyle: "Escolha um estilo musical.", s2_errVoice: "Escolha uma voz.",
      recipients: [
        { key: "wife", em: "💍", label: "A minha mulher", rel: "wife", cat: "partner", g: "f" },
        { key: "husband", em: "🤵", label: "O meu marido", rel: "husband", cat: "partner", g: "m" },
        { key: "girlfriend", em: "💖", label: "A minha namorada", rel: "girlfriend", cat: "partner", g: "f" },
        { key: "boyfriend", em: "💙", label: "O meu namorado", rel: "boyfriend", cat: "partner", g: "m" },
        { key: "mother", em: "🌷", label: "A minha mãe", rel: "mother", cat: "parent", g: "f" },
        { key: "father", em: "🌳", label: "O meu pai", rel: "father", cat: "parent", g: "m" },
        { key: "child", em: "👶", label: "Os meus filhos", rel: "child", cat: "child", g: "n" },
        { key: "friend", em: "🤝", label: "Um amigo ou uma amiga", rel: "friend", cat: "other", g: "n" },
        { key: "self", em: "🎁", label: "Para mim", rel: "myself", cat: "other", g: "n" },
        { key: "other", em: "✨", label: "Alguém especial", rel: "someone dear", cat: "other", g: "n" }
      ],
      s2_eyebrow: "O ambiente", s2_title: "Que estilo para a canção?", s2_sub: "Escolha o estilo que combina com a vossa história.",
      topTag: "Top",
      stylesPop: ["Pop português", "Balada romântica", "Surpreendam-me", "Fado", "Acústico", "Balada ao piano", "Música de arraial", "Rock português"],
      stylesExtra: ["Rap português", "Soul / R&B", "Kizomba", "Pop dançável", "Casamento / Primeira dança", "Canção infantil", "Outro estilo"],
      moreStyles: "Mais estilos ▾", lessStyles: "Menos estilos ▴",
      voiceLabel: "Que voz?", voiceHint: "Recomendamos que escolha uma voz do seu próprio género: assim, a canção fica mais pessoal.", voices: ["Cantora", "Cantor", "Sem preferência"],
      s3_eyebrow: "Personalidade", s3_titlePre: "O que torna ", s3_titleName: "esta pessoa", s3_titlePost: " tão especial?", s3_sub: "Descreva o carácter e as qualidades de que mais gosta.",
      qualities: ["Carinho", "Generosidade", "Humor", "Ternura", "Força", "Bondade", "Paixão", "Cumplicidade", "Coragem", "Espontaneidade", "Lealdade", "Alegria"],
      qmoreLabel: "As qualidades mais bonitas", qmorePh: "Paciência, sabedoria, sentido de humor, presença nos momentos que contam? Conte-nos o que torna esta pessoa única.", facult: "opcional",
      s4_eyebrow: "Os vossos momentos", s4_title: "As vossas memórias mais bonitas", memPh: "Como se conheceram, os anos que marcaram, as piadas que só vocês percebem, os momentos que fizeram a vossa história…", memHint: "Quanto mais precisos os pormenores (lugares, datas, alcunhas), mais comovente fica a canção.",
      memSubs: {
        partner: "Que momentos com esta pessoa significam mais para si?",
        parent: "Que momentos com esta pessoa significam mais para si?",
        child: "Que momentos com esta pessoa significam mais para si?",
        other: "Que momentos com esta pessoa significam mais para si?"
      },
      prompts: {
        partner: ["Como nos conhecemos…", "Uma gargalhada a dois…", "Um momento que conta…"],
        parent: ["Uma memória de infância…", "O que me ensinou…", "Um hábito que nos faz sorrir…"],
        child: ["O dia em que nasceu…", "Um momento só vosso…", "Aquilo que nos enche de orgulho…"],
        other: ["Como se conheceram…", "Um momento inesquecível…", "O que vos une…"]
      },
      s5_eyebrow: "O coração", s5_title: "Uma palavra do coração?", s5_sub: "Uma mensagem pessoal que gostaria de ouvir na canção.",
      msgPH: { f: "Quero que ela saiba que…", m: "Quero que ele saiba que…", n: "O que eu gostaria de dizer é…" },
      studioLabel: "Uma última palavra para o estúdio?", studioPh: "Um desejo, algo a evitar, um pormenor que conta…",
      p6_eyebrow: "O presente", p6_title: "Uma lembrança?", p6_sub: "Uma placa ou um íman com o código QR da sua canção, entregue em sua casa.",
      p6_plaque: "Placa QR", p6_magnet: "Íman QR", p6_socle: "Adicionar a base de madeira",
      p6_titleLabel: "Título da canção", p6_titlePh: "O título que quer gravar", p6_titleMax: "Máximo de 40 caracteres",
      p6_artistLabel: "Artista", p6_artistPh: "Uma assinatura, uma piscadela de olho, uma alcunha", p6_artistMax: "Máximo de 30 caracteres",
      p6_photoLabel: "Foto da capa", p6_photoBtn: "Escolher uma foto", p6_photoHelp: "JPG, PNG, WEBP ou foto de iPhone · máx. 20 MB",
      p6_errFields: "Indique o título e o artista a gravar.", p6_errPhoto: "Este produto precisa de uma foto.",
      p6_errPhotoBig: "Foto demasiado grande (máx. 20 MB).", p6_errPhotoType: "Formato não suportado. Use JPG, PNG ou WEBP.", p6_converting: "A converter a foto do iPhone…",
      p7_eyebrow: "Último passo", p7_title: "Entrega e audição", p7_sub: "Escolha como e quando quer receber a sua canção.",
      p7_deliveryLabel: "Entrega da canção", p7_std: "Normal", p7_stdMeta: "No prazo de 48 h · por e-mail", p7_stdPrice: "Incluída",
      p7_express: "Expresso", p7_expressMeta: "No prazo de 24 h · com prioridade",
      p7_diffusionLabel: "Streaming", p7_streaming: "Streaming no Spotify e no Apple Music", p7_streamingMeta: "A sua canção em todas as plataformas",
      p7_sessions: "Próximas sessões de gravação",
      sessions: { delivery: "Entrega:", reserved: "RESERVADO", days: ["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"], months: ["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro"] },
      errGeneric: "Algo correu mal. Verifique a sua ligação e tente novamente.",
      props: { recipient: "Para quem", firstName: "Nome", style: "Estilo musical", voice: "Voz", occasion: "Ocasião", qualities: "Qualidades", memories: "Memórias", difficulties: "Momentos difíceis", message: "Mensagem", studio: "Nota para o estúdio", songTitle: "Título da canção", artist: "Artista", socle: "Base de madeira", yes: "Sim" }
    },
    fi: {
      privacy: "Vastauksesi pysyvät yksityisinä",
      back: "Takaisin", skip: "Ohita", skipPhysical: "Ei kiitos, jatka ilman", next: "Jatka", stepWord: "Vaihe", ofWord: "/",
      ctaFinal: "Tilaa lauluni",
      submitting: "Tilaustasi valmistellaan…", uploading: "Kuvaasi lähetetään…",
      stepNames: ["Kenelle", "Tyyli", "Persoonallisuus", "Yhteiset muistot", "Sydämestä", "Yhteenveto", "Lisävalinnat", "Muistoesine"],
      ask: {"wife": "Mikä on vaimosi nimi?", "husband": "Mikä on miehesi nimi?", "girlfriend": "Mikä on tyttöystäväsi nimi?", "boyfriend": "Mikä on poikaystäväsi nimi?", "mother": "Mikä on äitisi nimi?", "father": "Mikä on isäsi nimi?", "child": "Mitkä ovat lastesi nimet?", "friend": "Mikä on ystäväsi nimi?", "self": "Mikä on etunimesi?", "other": "Mikä on hänen nimensä?"},
      s2_titlePre: "Mikä tyyli sopii laululle, jonka saa ",
      s2_titlePost: "?",
      s4_titlePre: "Sinä ja ",
      s4_titlePost: ": kauneimmat muistonne",
      s5_titlePre: "Mitä haluat, että ",
      s5_titlePost: " tietää?",
      p6_titlePre: "Saako ",
      p6_titlePost: " myös muistoesineen?",
      ctaNoThanks: "Ei kiitos",
      g_title: "Rahat takaisin -takuu",
      g_body: "Rajattomasti muutoksia, kunnes rakastat laulua, tai saat kaikki rahasi takaisin.",
      o_delivPrefix: "Toimitetaan",
      t_secure: "Turvallinen maksu",
      t_refund: "Rahat takaisin -takuu",
      t_free: "Maksuttomat muutokset",
      faqTitle: "Usein kysyttyä",
      faq: [["Miten saan lauluni?", "Laulusi saapuu sähköpostiisi korkealaatuisena MP3-tiedostona, ja mukana on yksityinen linkki, jolla voit kuunnella, ladata ja jakaa sen."], ["Onko maksaminen turvallista?", "Kyllä. Kaikki maksut kulkevat Shopifyn kautta pankkitason salauksella. Emme koskaan tallenna korttitietojasi."], ["Voinko pyytää muutoksia?", "Tietysti. Muokkaamme laulua maksutta, kunnes olet täysin tyytyväinen."], ["Kuinka nopeasti saan sen?", "Noin 48 tunnissa vakiotoimituksella. 24 tunnin vaihtoehdolla laulusi on valmis jo huomenna."]],
      r_title: "Tarkista laulusi tiedot",
      x_title: "Tutustu muutamaan lauluumme",
      o_cardTitle: "Laulun saaja:",
      o_cardEdit: "Muokkaa",
      o_express: "Toimitus 24 tunnissa",
      o_expressMeta: "Sama laulu, toimitettuna 24 tunnin kuluessa",
      o_stream: "Laulusi Spotifyssa ja Apple Musicissa",
      o_streamMeta: "Lisää se arjen soittolistoillesi.",
      o_lyr: "Laulun sanat ikuisesti talteen",
      o_lyrMeta: "Tulostettava versio, jossa on nimi ja laulun kansikuva. Säilytettäväksi, lahjaksi tai kehystettäväksi.",
      o_eyebrow: "Lisävalinnat",
      o_title: "Viimeistele laulusi",
      o_sub: "Näillä valinnoilla lahjasta tulee vielä täydellisempi.",
      o_paroles: "Tulostettavat sanat",
      o_parolesMeta: "Laulun sanat valmiina kehystettäviksi",
      o_songLine: "Henkilökohtainen laulusi",
      o_optLabel: "Lisää lauluusi",
      o_uncheck: "Poista valinta niistä, joita et tarvitse",
      r_eyebrow: "Melkein valmista",
      r_sub: "Lue vastauksesi vielä kerran. Voit muuttaa kaikkea yhdellä napautuksella.",
      r_edit: "Muokkaa",
      r_pour: "Kenelle",
      r_occ: "Tilaisuus",
      r_style: "Tyyli",
      r_voice: "Ääni",
      r_qual: "Luonteenpiirteet",
      r_mem: "Yhteiset muistot",
      r_msg: "Sydämestä",
      r_vide: "Ei täytetty",
      r_photoTitle: "Lisää kuva",
      r_photoSub: "Se näkyy laulun sivulla.",
      r_photoBtn: "Valitse kuva",
      r_photoFree: "Ilmainen",
      r_photoDone: "Kuva lisätty",
      r_photoChange: "Vaihda",
      r_photoConv: "Kuvaasi muunnetaan…",
      r_photoErrType: "Tätä kuvamuotoa ei tueta. Kokeile JPG- tai PNG-kuvaa.",
      r_photoErrBig: "Kuva on liian suuri. Kokeile pienempää.",
      occLabel: "Mihin tilaisuuteen?", occOtherPh: "Kerro meille tilaisuudesta…",
      occasions: [
        { em: "🎂", label: "Syntymäpäivä" }, { em: "💞", label: "Vuosipäivä" }, { em: "💍", label: "Häät" }, { em: "👶", label: "Vauvan syntymä" }, { em: "🌅", label: "Eläkkeelle jäänti" },
        { em: "🕊️", label: "Muistolle" }, { em: "❤️", label: "Ystävänpäivä" }, { em: "🌷", label: "Äitienpäivä / Isänpäivä" }, { em: "🎁", label: "Valmistujaiset" }, { em: "🎄", label: "Joulu" },
        { em: "✨", label: "Muuten vain" }, { em: "✍️", label: "Muu tilaisuus" }
      ],
      diffLabel: "Vaikea aika, jonka olette kestäneet yhdessä?", diffPh: "Sairaus, välimatka, menetys… se, mistä olette selvinneet yhdessä.",
      s1_title: "Kenelle tämä laulu on?", s1_sub: "Kerro meille tästä tärkeästä ihmisestä.",
      nameLabel: "Etunimi", namePh: "Esim. Mikko", s1_errRecipient: "Valitse, kenelle laulu on.", s1_errName: "Kirjoita etunimi: se lauletaan kertosäkeessä.",
      s2_errStyle: "Valitse musiikkityyli.", s2_errVoice: "Valitse ääni.",
      recipients: [
        { key: "wife", em: "💍", label: "Vaimolleni", rel: "wife", cat: "partner", g: "f" },
        { key: "husband", em: "🤵", label: "Miehelleni", rel: "husband", cat: "partner", g: "m" },
        { key: "girlfriend", em: "💖", label: "Tyttöystävälleni", rel: "girlfriend", cat: "partner", g: "f" },
        { key: "boyfriend", em: "💙", label: "Poikaystävälleni", rel: "boyfriend", cat: "partner", g: "m" },
        { key: "mother", em: "🌷", label: "Äidilleni", rel: "mother", cat: "parent", g: "f" },
        { key: "father", em: "🌳", label: "Isälleni", rel: "father", cat: "parent", g: "m" },
        { key: "child", em: "👶", label: "Lapsilleni", rel: "child", cat: "child", g: "n" },
        { key: "friend", em: "🤝", label: "Ystävälleni", rel: "friend", cat: "other", g: "n" },
        { key: "self", em: "🎁", label: "Itselleni", rel: "myself", cat: "other", g: "n" },
        { key: "other", em: "✨", label: "Jollekulle erityiselle", rel: "someone dear", cat: "other", g: "n" }
      ],
      s2_eyebrow: "Tunnelma", s2_title: "Mikä tyyli laululle?", s2_sub: "Valitse tyyli, joka sopii tarinaanne.",
      topTag: "Suosituin",
      stylesPop: ["Suomipop", "Balladi", "Yllätä minut", "Iskelmä", "Akustinen", "Pianoballadi", "Yhteislaulu", "Suomirock"],
      stylesExtra: ["Suomiräp", "Tango", "Tanssipop", "Humppa", "Häät / Häävalssi", "Lastenlaulu", "Muu tyyli"],
      moreStyles: "Lisää tyylejä ▾", lessStyles: "Vähemmän tyylejä ▴",
      voiceLabel: "Millainen ääni?", voiceHint: "Suosittelemme valitsemaan oman sukupuolesi äänen: silloin laulu tuntuu henkilökohtaisemmalta.", voices: ["Naislaulaja", "Mieslaulaja", "Ei väliä"],
      s3_eyebrow: "Persoonallisuus", s3_titlePre: "Millainen on ", s3_titleName: "tämä ihminen", s3_titlePost: "?", s3_sub: "Kuvaile luonnetta ja niitä piirteitä, joita rakastat eniten.",
      qualities: ["Huolehtiva", "Antelias", "Hauska", "Lempeä", "Vahva", "Ystävällinen", "Intohimoinen", "Läheinen", "Rohkea", "Spontaani", "Uskollinen", "Säteilevä"],
      qmoreLabel: "Hänen kauneimmat piirteensä", qmorePh: "Kärsivällinen, viisas, hauska, suojeleva, aina paikalla, kun tarvitaan? Kerro, mikä tekee hänestä niin erityisen.", facult: "valinnainen",
      s4_eyebrow: "Yhteiset hetket", s4_title: "Kauneimmat muistonne", memPh: "Miten tapasitte, merkitykselliset vuodet, vitsit, jotka vain te ymmärrätte, hetket, joista tarinanne syntyi…", memHint: "Mitä tarkemmin kerrot (paikat, päivämäärät, lempinimet), sitä koskettavampi laulusta tulee.",
      memSubs: {
        partner: "Mitkä hetket hänen kanssaan merkitsevät sinulle eniten?",
        parent: "Mitkä hetket hänen kanssaan merkitsevät sinulle eniten?",
        child: "Mitkä hetket hänen kanssaan merkitsevät sinulle eniten?",
        other: "Mitkä hetket hänen kanssaan merkitsevät sinulle eniten?"
      },
      prompts: {
        partner: ["Miten tapasimme…", "Yhteiset naurut…", "Hetki, jolla on merkitystä…"],
        parent: ["Muisto lapsuudestani…", "Mitä hän opetti minulle…", "Tapa, joka saa hymyilemään…"],
        child: ["Päivä, jona hän syntyi…", "Teidän yhteinen hetkenne…", "Mistä olet ylpeä…"],
        other: ["Miten tutustuitte…", "Unohtumaton hetki…", "Mikä teitä yhdistää…"]
      },
      s5_eyebrow: "Sydän", s5_title: "Sanat sydämestä?", s5_sub: "Henkilökohtainen viesti, jonka haluaisit kuulla laulussa.",
      msgPH: { f: "Haluan hänen tietävän, että…", m: "Haluan hänen tietävän, että…", n: "Haluan sanoa, että…" },
      studioLabel: "Vielä viimeinen sana studiolle?", studioPh: "Toive, jotain vältettävää, tärkeä yksityiskohta…",
      p6_eyebrow: "Lahja", p6_title: "Muistoesine?", p6_sub: "Taulu tai magneetti, jossa on laulusi QR-koodi, toimitettuna kotiisi.",
      p6_plaque: "QR-taulu", p6_magnet: "QR-magneetti", p6_socle: "Lisää puinen jalusta",
      p6_titleLabel: "Laulun nimi", p6_titlePh: "Nimi, jonka haluat kaiverrettavan", p6_titleMax: "Enintään 40 merkkiä",
      p6_artistLabel: "Artisti", p6_artistPh: "Allekirjoitus, pieni vihje, lempinimi", p6_artistMax: "Enintään 30 merkkiä",
      p6_photoLabel: "Kansikuva", p6_photoBtn: "Valitse kuva", p6_photoHelp: "JPG, PNG, WEBP tai iPhone-kuva · enint. 20 Mt",
      p6_errFields: "Kirjoita kaiverrettava laulun nimi ja artisti.", p6_errPhoto: "Tähän tuotteeseen tarvitaan kuva.",
      p6_errPhotoBig: "Kuva on liian suuri (enint. 20 Mt).", p6_errPhotoType: "Muotoa ei tueta. Käytä JPG-, PNG- tai WEBP-kuvaa.", p6_converting: "iPhone-kuvaa muunnetaan…",
      p7_eyebrow: "Viimeinen vaihe", p7_title: "Toimitus ja kuuntelu", p7_sub: "Valitse, miten ja milloin saat laulusi.",
      p7_deliveryLabel: "Laulun toimitus", p7_std: "Vakio", p7_stdMeta: "48 tunnin kuluessa · sähköpostilla", p7_stdPrice: "Sisältyy hintaan",
      p7_express: "Pika", p7_expressMeta: "24 tunnin kuluessa · etusijalla",
      p7_diffusionLabel: "Suoratoisto", p7_streaming: "Suoratoisto Spotifyssa ja Apple Musicissa", p7_streamingMeta: "Laulusi kaikilla alustoilla",
      p7_sessions: "Tulevat äänityssessiot",
      sessions: { delivery: "Toimitus:", reserved: "VARATTU", days: ["sunnuntai","maanantai","tiistai","keskiviikko","torstai","perjantai","lauantai"], months: ["tammikuuta","helmikuuta","maaliskuuta","huhtikuuta","toukokuuta","kesäkuuta","heinäkuuta","elokuuta","syyskuuta","lokakuuta","marraskuuta","joulukuuta"] },
      errGeneric: "Jokin meni pieleen. Tarkista yhteytesi ja yritä uudelleen.",
      props: { recipient: "Kenelle", firstName: "Etunimi", style: "Musiikkityyli", voice: "Ääni", occasion: "Tilaisuus", qualities: "Luonteenpiirteet", memories: "Muistot", difficulties: "Vaikeat ajat", message: "Viesti", studio: "Viesti studiolle", songTitle: "Laulun nimi", artist: "Artisti", socle: "Puinen jalusta", yes: "Kyllä" }
    },
  };
  var T = I18N[LOC];
  // 28/10 (Thibaut) : propriétés du panier dans la langue du client (avant : anglais forcé pour es, ja, it, nl, sv, da, nb, pt, fi le 21/10)

  // ============================================================
  //  State
  // ============================================================
  var MAX = 8, cur = 1;
  var A = {
    recipientKey: '', recipientLabel: '', recipientText: '', cat: 'other', gender: 'n', name: '',
    occasion: '', occasionOther: '',
    style: '', styleOther: '', voice: '',
    qualities: [], qmore: '', memories: '', difficulties: '', message: '', studio: '',
    u1: { product: '', socle: false, songTitle: '', artist: '' },
    u2: { delivery: 'standard', streaming: false, paroles: false }   // 02/11 (Thibaut) : plus rien de coché par défaut (24 h, streaming, paroles)
  };

  // ============================================================
  //  Reprise apres actualisation
  // ============================================================
  // Les reponses restent dans le navigateur du visiteur, rien n est envoye ailleurs.
  // La photo n est pas gardee : un fichier ne se stocke pas ainsi, il faudra la remettre.
  var CLE_REPRISE = 'ym_creation_v3';
  var DUREE_REPRISE = 7 * 24 * 60 * 60 * 1000;
  var minuteurReprise = null;

  function sauverProgression() {
    try {
      localStorage.setItem(CLE_REPRISE, JSON.stringify({ t: Date.now(), etape: cur, rep: A }));
    } catch (e) {}
  }
  function planifierSauvegarde() {
    clearTimeout(minuteurReprise);
    minuteurReprise = setTimeout(sauverProgression, 400);
  }
  function oublierProgression() {
    try { localStorage.removeItem(CLE_REPRISE); } catch (e) {}
  }

  // On ne recopie que des cles deja connues, et seulement si le type correspond. Une
  // sauvegarde laissee par une version precedente du quiz ne peut donc rien casser.
  function reprendreProgression() {
    var brut, d, k, s, v;
    try { brut = localStorage.getItem(CLE_REPRISE); } catch (e) { return; }
    if (!brut) return;
    try { d = JSON.parse(brut); } catch (e) { oublierProgression(); return; }
    if (!d || !d.rep || typeof d.t !== 'number' || Date.now() - d.t > DUREE_REPRISE) {
      oublierProgression(); return;
    }
    function type(x) { return Object.prototype.toString.call(x); }
    for (k in A) {
      if (!Object.prototype.hasOwnProperty.call(A, k)) continue;
      v = d.rep[k];
      if (v === undefined || v === null || type(v) !== type(A[k])) continue;
      if (type(v) === '[object Object]') {
        for (s in A[k]) {
          if (Object.prototype.hasOwnProperty.call(A[k], s) && v[s] !== undefined &&
              type(v[s]) === type(A[k][s])) A[k][s] = v[s];
        }
      } else {
        A[k] = v;
      }
    }
    A.name = nomPropre(A.name);
    var e = parseInt(d.etape, 10);
    if (e >= 1 && e <= MAX) cur = e;
  }
  var photoFile = null, songPhotoFile = null, heicPromise = null;

  // ============================================================
  //  Helpers
  // ============================================================
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function flatten(s) {
    return String(s == null ? '' : s).replace(/[\r\n]+/g, '. ').replace(/\s+/g, ' ').replace(/\\/g, '').replace(/"/g, "'").trim();
  }
  function q(sel) { return root.querySelector(sel); }
  function validId(v) { return v && !isNaN(Number(v)) && Number(v) > 0; }
  function optBtn(label, em, extra) {
    return '<button type="button" class="ymq-opt"' + (extra || '') + ' aria-pressed="false">' +
      (em ? '<span class="ymq-em">' + em + '</span>' : '') + esc(label) + '</button>';
  }
  function chip(label, extra, mini) {
    return '<button type="button" class="ymq-chip"' + (extra || '') + ' aria-pressed="false">' + esc(label) +
      (mini ? '<span class="ymq-mini">' + esc(mini) + '</span>' : '') + '</button>';
  }
  // Un prenom, c est court et sur une seule ligne. Sans cette borne, un collage
  // se retrouve dans les paroles, dans les mails et sur la page d ecoute.
  var NOM_MAX = 40;
  function nomPropre(v) {
    return String(v == null ? '' : v).replace(/[\r\n\t]+/g, ' ').replace(/\s{2,}/g, ' ').slice(0, NOM_MAX);
  }

  function nameEcho() { return A.name ? esc(A.name) : T.s3_titleName; }

  // Le libelle du champ prenom suit le destinataire choisi. Repli sur le libelle
  // generique tant que rien n est selectionne.
  function questionPrenom() {
    return (T.ask && T.ask[A.recipientKey]) || T.nameLabel;
  }
  function isOther(v) { return /autre|other|andere|otr[oa]|altr[oa]|その他/i.test(v || ''); }

  // ============================================================
  //  Step markup
  // ============================================================
  function persoHTML() {
    var u = A.u1;
    return '<div class="ymq-perso" id="ymq-perso"' + (u.product ? '' : ' hidden') + '>' +
      '<label class="ymq-check" id="ymq-socle-row"' + (u.product === 'plaque' ? '' : ' hidden') + '><input type="checkbox" id="ymq-socle"' + (u.socle ? ' checked' : '') + '><span>' + esc(T.p6_socle) + '</span><span class="ymq-cprice">' + (PRICES.socle ? '+ ' + esc(PRICES.socle) : '') + '</span></label>' +
      '<div class="ymq-field" style="margin-top:12px"><label for="ymq-ptitle">' + esc(T.p6_titleLabel) + ' *</label><input type="text" id="ymq-ptitle" maxlength="40" value="' + esc(u.songTitle) + '" placeholder="' + esc(T.p6_titlePh) + '"><p class="ymq-hint">' + esc(T.p6_titleMax) + '</p></div>' +
      '<div class="ymq-field"><label for="ymq-partist">' + esc(T.p6_artistLabel) + ' *</label><input type="text" id="ymq-partist" maxlength="30" value="' + esc(u.artist) + '" placeholder="' + esc(T.p6_artistPh) + '"><p class="ymq-hint">' + esc(T.p6_artistMax) + '</p></div>' +
      '<div class="ymq-field"><label>' + esc(T.p6_photoLabel) + ' *</label>' +
      '<div class="ymq-photo"><div class="ymq-photo-prev" id="ymq-photo-prev">' + (photoFile ? '' : '🖼') + '</div>' +
      '<label class="ymq-photo-btn"><span id="ymq-photo-lbl">' + esc(T.p6_photoBtn) + '</span><input type="file" id="ymq-photo" accept="image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif" hidden></label></div>' +
      '<p class="ymq-hint">' + esc(T.p6_photoHelp) + '</p></div>' +
      '<p class="ymq-perr" id="ymq-p6-err" hidden></p></div>';
  }
  function productCard(key, name, img, price) {
    return '<button type="button" class="ymq-pcard" data-prod="' + key + '" aria-pressed="' + (A.u1.product === key ? 'true' : 'false') + '">' +
      (img ? '<img class="ymq-pimg" src="' + esc(img) + '" alt="' + esc(name) + '" loading="lazy">' : '') +
      '<span><span class="ymq-pname">' + esc(name) + '</span><span class="ymq-pprice">' + esc(price || '') + '</span></span>' +
      '<span class="ymq-pcheck">✓</span></button>';
  }

  function stepHTML(n) {
    if (n === 1) {
      var opts = T.recipients.map(function (r, i) { return optBtn(r.label, r.em, ' data-i="' + i + '"'); }).join('');
      return '<h1>' + T.s1_title + '</h1><p class="ymq-sub">' + T.s1_sub + '</p>' +
        '<div class="ymq-grid" id="ymq-recipients">' + opts + '</div>' +
        '<div class="ymq-field"><label for="ymq-name" id="ymq-namelbl">' + esc(questionPrenom()) + '</label>' +
        '<input type="text" id="ymq-name" maxlength="40" value="' + esc(A.name) + '" placeholder="' + esc(T.namePh) + '"></div>' +
        '<p class="ymq-hint" id="ymq-s1-err" hidden></p>' +
        '<p class="ymq-lbl">' + T.occLabel + '</p>' +
        '<div class="ymq-chips" id="ymq-occasions">' + T.occasions.map(function (o) { return chip(o.em + ' ' + o.label, ' data-occ="' + esc(o.label) + '"'); }).join('') + '</div>' +
        '<div class="ymq-field" id="ymq-occ-other"' + (isOther(A.occasion) ? '' : ' hidden') + '>' +
        '<input type="text" id="ymq-occother" value="' + esc(A.occasionOther) + '" placeholder="' + esc(T.occOtherPh) + '" maxlength="60"></div>';
    }
    if (n === 2) {
      var pop = T.stylesPop.map(function (s, i) { return chip(s, ' data-style="' + esc(s) + '"', i === 0 ? T.topTag : ''); }).join('');
      var extra = T.stylesExtra.map(function (s) { return chip(s, ' data-style="' + esc(s) + '"'); }).join('');
      var voices = T.voices.map(function (v) { return optBtn(v, '', ' data-voice="' + esc(v) + '" style="justify-content:center"'); }).join('');
      return '<h1>' + T.s2_titlePre + '<em>' + nameEcho() + '</em>' + T.s2_titlePost + '</h1>' +
        '<div class="ymq-chips" id="ymq-styles">' + pop + '</div>' +
        '<button type="button" class="ymq-more" id="ymq-more">' + T.moreStyles + '</button>' +
        '<div class="ymq-chips ymq-styles-extra" id="ymq-styles-extra" hidden>' + extra + '</div>' +
        '<p class="ymq-lbl">' + T.voiceLabel + '</p>' +
        '<p class="ymq-sub" style="margin:-4px 0 10px">' + T.voiceHint + '</p>' +
        '<div class="ymq-grid ymq-grid-3" id="ymq-voices">' + voices + '</div>' +
        '<p class="ymq-hint" id="ymq-s2-err" hidden></p>';
    }
    if (n === 3) {
      return '<h1>' + T.s3_titlePre + '<em>' + nameEcho() + '</em>' + T.s3_titlePost + '</h1><p class="ymq-sub">' + T.s3_sub + '</p>' +
        '<div class="ymq-field ymq-grow"><label for="ymq-qmore">' + T.qmoreLabel + '</label>' +
        '<textarea id="ymq-qmore" placeholder="' + esc(T.qmorePh) + '">' + esc(A.qmore) + '</textarea></div>';
    }
    if (n === 4) {
      var sub = T.memSubs[A.cat] || T.memSubs.other;
      return '<h1>' + T.s4_titlePre + '<em>' + nameEcho() + '</em>' + T.s4_titlePost + '</h1><p class="ymq-sub">' + esc(sub) + '</p>' +
        '<div class="ymq-field ymq-grow"><textarea id="ymq-memories" placeholder="' + esc(T.memPh) + '">' + esc(A.memories) + '</textarea></div>' +
        '<div class="ymq-field"><label for="ymq-diff">' + T.diffLabel + '</label>' +
        '<textarea id="ymq-diff" style="min-height:96px" placeholder="' + esc(T.diffPh) + '">' + esc(A.difficulties) + '</textarea></div>';
    }
    if (n === 5) {
      var ph = T.msgPH[A.gender] || T.msgPH.n;
      return '<h1>' + T.s5_titlePre + '<em>' + nameEcho() + '</em>' + T.s5_titlePost + '</h1><p class="ymq-sub">' + T.s5_sub + '</p>' +
        '<div class="ymq-field ymq-grow"><textarea id="ymq-message" placeholder="' + esc(ph) + '">' + esc(A.message) + '</textarea></div>' +
        '<div class="ymq-field"><label for="ymq-studio">' + T.studioLabel + '</label>' +
        '<textarea id="ymq-studio" style="min-height:96px" placeholder="' + esc(T.studioPh) + '">' + esc(A.studio) + '</textarea></div>';
    }
    if (n === 6) {
      var nom = A.name || A.recipientLabel || '';
      var occ = A.occasion === 'other' ? A.occasionOther : (A.occasion || '');
      var sty = A.style === 'other' ? A.styleOther : (A.style || '');
      var qua = (A.qualities || []).join(', ') + (A.qmore ? (A.qualities.length ? ', ' : '') + A.qmore : '');
      var mem = [A.memories, A.difficulties].filter(Boolean).join(' · ');
      var msg = A.message;
      function rrow(lbl, val, st) {
        return '<div class="ymq-rrow"><span class="ymq-rlbl">' + esc(lbl) + '</span>' +
          '<span class="ymq-rval' + (val ? '' : ' ymq-rvide') + '">' + esc(val || T.r_vide) + '</span>' +
          '<button type="button" class="ymq-redit" data-step="' + st + '">' + esc(T.r_edit) + '</button></div>';
      }
      var champPhoto = '<input type="file" accept="image/*" id="ymq-sp-input" hidden>';
      var ligneConv = '<p class="ymq-sp-load" id="ymq-sp-load" hidden></p>';
      var photoBloc = songPhotoFile
        ? '<div class="ymq-sp ymq-sp--done">' +
            '<div class="ymq-sp-row"><div class="ymq-sp-prev" id="ymq-sp-prev"></div>' +
            '<div class="ymq-sp-txt"><b>' + esc(T.r_photoDone) + '</b>' +
            '<span>' + esc(T.r_photoSub) + '</span></div></div>' +
            '<label class="ymq-sp-btn ymq-sp-btn--soft" id="ymq-sp-lbl">' + esc(T.r_photoChange) + champPhoto + '</label>' +
            ligneConv +
          '</div>'
        : '<div class="ymq-sp">' +
            '<div class="ymq-sp-head"><b>' + esc(T.r_photoTitle) + '</b>' +
            '<span class="ymq-sp-free">' + esc(T.r_photoFree) + '</span></div>' +
            '<p class="ymq-sp-sub">' + esc(T.r_photoSub) + '</p>' +
            '<label class="ymq-sp-btn" id="ymq-sp-lbl">' + esc(T.r_photoBtn) + champPhoto + '</label>' +
            ligneConv +
          '</div>';
      return '<h1>' + esc(T.r_title) + '</h1>' +
        '<div class="ymq-recap">' +
          rrow(T.r_pour, [(A.recipientText || A.recipientLabel), (A.name || '')].filter(Boolean).join(' · '), 1) +
          rrow(T.r_occ, occ, 1) +
          rrow(T.r_style, sty, 2) +
          rrow(T.r_voice, A.voice, 2) +
          rrow(T.r_qual, qua, 3) +
          rrow(T.r_mem, mem, 4) +
          rrow(T.r_msg, msg, 5) +
          rrow(T.studioLabel, A.studio, 5) +
        '</div>' +
        photoBloc +
        '<p class="ymq-perr" id="ymq-sp-err" hidden></p>';
    }
    if (n === 8) {
      return '<h1>' + T.p6_titlePre + '<em>' + nameEcho() + '</em>' + T.p6_titlePost + '</h1><p class="ymq-sub">' + T.p6_sub + '</p>' +
        '<div class="ymq-products" id="ymq-products">' +
        productCard('plaque', T.p6_plaque, IMAGES.plaque[LOC] || (LOC === 'fr' ? IMAGES.plaque.fr : IMAGES.plaque.en), PRICES.plaque) +
        productCard('magnet', T.p6_magnet, IMAGES.magnet[LOC] || (LOC === 'fr' ? IMAGES.magnet.fr : IMAGES.magnet.en), PRICES.magnet) +
        '</div>' + persoHTML();
    }
    if (n === 7) {
      var u2 = A.u2;
      var sty = A.style === 'other' ? A.styleOther : (A.style || '');
      var ligne2 = sty;
      var photoBig = songPhotoFile ? '<div class="ymq-photobig" id="ymq-ps-img"></div>' : '';
      function opt(id, checked, nom, meta, prix) {
        return '<label class="ymq-deliv"><input type="checkbox" id="' + id + '"' + (checked ? ' checked' : '') + '>' +
          '<span><span class="ymq-dname">' + esc(nom) + '</span><br><span class="ymq-dmeta">' + esc(meta) + '</span></span>' +
          '<span class="ymq-dprice">' + (prix ? '+ ' + esc(prix) : '') + '</span></label>';
      }
      return '<div class="ymq-reccard"><div class="ymq-reccard-ico">' + ICO_VINYLE + '</div>' +
          '<div class="ymq-reccard-txt">' +
            '<b>' + esc(T.o_cardTitle) + ' ' + esc(A.name || A.recipientLabel || '') + '</b>' +
            '<span>' + (ligne2 ? esc(ligne2) + ' · ' : '') + esc(T.o_delivPrefix) +
            ' <b id="ymq-delivdate">' + esc(dateLivraison(joursLivraison())) + '</b></span>' +
            '<button type="button" class="ymq-redit" data-step="6">' + ICO_CRAYON + esc(T.o_cardEdit) + '</button>' +
          '</div></div>' +
        '<div class="ymq-guarantee">' + ICO_BOUCLIER +
          '<div class="ymq-gtxt"><b>' + esc(T.g_title) + '</b><span>' + esc(T.g_body) + '</span></div></div>' +
        photoBig +
        '<div class="ymq-songline"><span class="ymq-dname">' + esc(T.o_songLine) + '</span>' +
        '<span class="ymq-dprice">' + esc(PRICES.song || '') + '</span></div>' +
        opt('ymq-express', u2.delivery === 'express', T.o_express, T.o_expressMeta, PRICES.express) +
        opt('ymq-streaming', u2.streaming, T.o_stream, T.o_streamMeta, PRICES.streaming) +
        opt('ymq-paroles', u2.paroles, T.o_lyr, T.o_lyrMeta, PRICES.paroles) +
        '<div class="ymq-sessions" id="ymq-sessions"></div>' +
        '<div class="ymq-rea3">' +
          '<span><i class="ymq-emo">🔒</i>' + esc(T.t_secure) + '</span>' +
          '<span><i class="ymq-emo">🛡️</i>' + esc(T.t_refund) + '</span>' +
          '<span class="ymq-rea3-full"><i class="ymq-emo">🎵</i>' + esc(T.t_free) + '</span>' +
        '</div>' +
        '<p class="ymq-perr" id="ymq-p7-err" hidden></p>';
    }
    return '';
  }


  // ============================================================
  //  Icones et date de livraison
  // ============================================================
  var ICO_VINYLE = '<svg viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="23" fill="#17172b"/>' +
    '<circle cx="24" cy="24" r="16.5" fill="none" stroke="#3c3c58" stroke-width="1.1"/>' +
    '<circle cx="24" cy="24" r="11.5" fill="none" stroke="#3c3c58" stroke-width="1.1"/>' +
    '<circle cx="24" cy="24" r="6.4" fill="#F4EEE2"/><circle cx="24" cy="24" r="1.7" fill="#17172b"/></svg>';
  var ICO_CRAYON = '<svg class="ymq-pico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/>' +
    '<path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';
  var ICO_BOUCLIER = '<svg class="ymq-gico" viewBox="0 0 24 24" aria-hidden="true">' +
    '<path d="M12 2l8 3.5v6C20 17 16.4 21.2 12 22.5 7.6 21.2 4 17 4 11.5v-6z" fill="#2F9E5F"/>' +
    '<path d="M8.4 12.2l2.5 2.5 4.7-4.9" fill="none" stroke="#fff" stroke-width="2.1" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // 24 h cochee : livree demain. Sinon 48 h. On affiche la vraie date, pas "demain".
  var LOCALES_DATE = { fr: 'fr-FR', en: 'en-US', de: 'de-DE', es: 'es-ES', ja: 'ja-JP', it: 'it-IT', nl: 'nl-NL', sv: 'sv-SE', da: 'da-DK', nb: 'nb-NO', pt: 'pt-PT', fi: 'fi-FI' };
  function dateLivraison(jours) {
    var d = new Date(); d.setDate(d.getDate() + jours);
    try { return d.toLocaleDateString(LOCALES_DATE[LOC] || 'fr-FR', { day: 'numeric', month: 'long' }); }
    catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
  }
  function joursLivraison() { return A.u2.delivery === 'express' ? 1 : 2; }

  // Meme bouton, meme destination : seul le nom change selon qu un souvenir est coche.
  function libelleCta() {
    if (cur < MAX) return T.next;
    return A.u1.product ? T.ctaFinal : T.ctaNoThanks;
  }

  // Judge.me reserve a sa boite d avis nettement plus de hauteur que ses avis n en occupent :
  // 5 049 px de vide constates en mobile apres deux "Charger plus". On se contente de recoller
  // la hauteur de la boite a son contenu. On ne touche ni a sa mise en page, ni a ses colonnes,
  // ni a ses photos.
  function ajusterHauteurAvis() {
    var boite = document.querySelector('#ymq-reviews .jdgm-rev-widg__reviews');
    if (!boite) return;
    var items = boite.querySelectorAll('.jdgm-rev');
    if (!items.length) return;
    var haut = boite.getBoundingClientRect().top, bas = haut, i, b;
    for (i = 0; i < items.length; i++) {
      b = items[i].getBoundingClientRect().bottom;
      if (b > bas) bas = b;
    }
    var besoin = Math.ceil(bas - haut);
    if (besoin > 40 && boite.getBoundingClientRect().height - besoin > 24) {
      boite.style.height = besoin + 'px';
    }
  }

  // Les avis arrivent par paquets de huit. A chaque arrivee, on repasse ajuster la hauteur,
  // plusieurs fois, parce que Judge.me la refixe apres coup et que les photos se chargent
  // encore. On n observe que l ajout d avis, jamais les styles, pour ne pas boucler.
  var observateurAvis = null;
  function surveillerAvis() {
    var boite = document.querySelector('#ymq-reviews .jdgm-rev-widg__reviews');
    if (!boite || observateurAvis || !window.MutationObserver) return;
    observateurAvis = new MutationObserver(function () {
      setTimeout(ajusterHauteurAvis, 500);
      setTimeout(ajusterHauteurAvis, 1500);
      setTimeout(ajusterHauteurAvis, 3000);
    });
    observateurAvis.observe(boite, { childList: true });
  }

  // Au depliage, on previent le widget que la place a change, puis on ajuste.
  function replacerAvis() {
    var essais = 0;
    function reveiller() {
      try { window.dispatchEvent(new Event('resize')); } catch (e) {}
      surveillerAvis();
      ajusterHauteurAvis();
      if (++essais < 4) setTimeout(reveiller, 900);
    }
    setTimeout(reveiller, 80);
  }

  function faqHTML() {
    var out = '<p class="ymq-faqtitle">' + esc(T.faqTitle) + '</p>', i;
    for (i = 0; i < T.faq.length; i++) {
      out += '<details><summary>' + esc(T.faq[i][0]) + '</summary><p>' + esc(T.faq[i][1]) + '</p></details>';
    }
    return out;
  }

  // ============================================================
  //  Sessions widget (urgence douce, comme le quiz v1)
  // ============================================================
  function renderSessions() {
    var box = q('#ymq-sessions'); if (!box) return;
    var s = T.sessions, now = new Date(), totalMin = now.getHours() * 60 + now.getMinutes();
    var d1 = new Date(now); d1.setDate(d1.getDate() + 1);
    var d2 = new Date(now); d2.setDate(d2.getDate() + 2);
    var pct1 = Math.min(98, Math.round(75 + (totalMin / 1440) * 23));
    var pct2 = Math.min(98, Math.round(45 + (totalMin / 1440) * 35));
    function col(p) { var lo = p < 50 ? [[42,140,90],[234,176,8],(p) / 50] : [[234,176,8],[200,74,31],(p - 50) / 50]; var a = lo[0], b = lo[1], t = lo[2]; return 'rgb(' + Math.round(a[0] + (b[0]-a[0])*t) + ',' + Math.round(a[1] + (b[1]-a[1])*t) + ',' + Math.round(a[2] + (b[2]-a[2])*t) + ')'; }
    function fmt(d) {
      if (LOC === 'ja') return s.months[d.getMonth()] + d.getDate() + '日（' + s.days[d.getDay()] + '）' + s.delivery;   // 21/10
      return s.delivery + ' ' + s.days[d.getDay()] + ' ' + d.getDate() + ' ' + s.months[d.getMonth()]; }
    function item(d, p) { return '<div class="ymq-session"><div class="ymq-srow"><span>' + esc(fmt(d)) + '</span><span class="ymq-sstatus">' + p + '% ' + esc(s.reserved) + '</span></div><div class="ymq-sbar"><span class="ymq-sfill" style="width:' + p + '%;background:' + col(p) + '"></span></div></div>'; }
    box.innerHTML = '<div class="ymq-sessions-t"><span class="ymq-sdot"></span>' + esc(T.p7_sessions) + '</div>' + item(d1, pct1) + item(d2, pct2);
  }

  // ============================================================
  //  Photo (HEIC iPhone → JPEG, taille, type)
  // ============================================================
  function loadScript(src) { return new Promise(function (res, rej) { var s = document.createElement('script'); s.src = src; s.async = true; s.onload = res; s.onerror = function () { rej(new Error('load ' + src)); }; document.head.appendChild(s); }); }
  function ensureHeic2Any() {
    if (window.heic2any) return Promise.resolve();
    if (!heicPromise) heicPromise = loadScript('https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js').catch(function () { return loadScript('https://unpkg.com/heic2any@0.0.4/dist/heic2any.min.js'); });
    return heicPromise;
  }
  function heicViaCanvas(file) {
    return new Promise(function (res, rej) {
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () { try { var c = document.createElement('canvas'); c.width = img.naturalWidth; c.height = img.naturalHeight; c.getContext('2d').drawImage(img, 0, 0); URL.revokeObjectURL(url); c.toBlob(function (b) { b ? res(b) : rej(new Error('toBlob')); }, 'image/jpeg', 0.85); } catch (e) { rej(e); } };
      img.onerror = function () { URL.revokeObjectURL(url); rej(new Error('native heic')); };
      img.src = url;
    });
  }
  function convertHeic(file) {
    var base = (file.name || 'photo').replace(/\.(heic|heif)$/i, '') + '.jpg';
    return heicViaCanvas(file).then(function (b) { return new File([b], base, { type: 'image/jpeg' }); }).catch(function () {
      return ensureHeic2Any().then(function () { return window.heic2any({ blob: file, toType: 'image/jpeg', quality: 0.85 }); }).then(function (r) { var b = Array.isArray(r) ? r[0] : r; return new File([b], base, { type: 'image/jpeg' }); });
    });
  }
  function showSongPhoto() {
    var prev = q('#ymq-sp-prev');
    if (prev && songPhotoFile) { prev.innerHTML = '<img src="' + URL.createObjectURL(songPhotoFile) + '" alt="">'; }
  }
  function onSongPhoto(ev) {
    var input = ev.target, err = q('#ymq-sp-err'), conv = q('#ymq-sp-load');
    var file = input.files && input.files[0];
    if (err) { err.hidden = true; err.textContent = ''; }
    if (!file) { songPhotoFile = null; return; }
    if (file.size > 20 * 1024 * 1024) {
      songPhotoFile = null;
      if (err) { err.textContent = T.r_photoErrBig; err.hidden = false; }
      return;
    }
    var isHeic = /heic|heif/i.test(file.type) || /\.(heic|heif)$/i.test(file.name);
    var p = Promise.resolve(file);
    if (isHeic) {
      if (conv) { conv.textContent = T.r_photoConv; conv.hidden = false; }
      p = convertHeic(file);
    }
    p.then(function (f) {
      songPhotoFile = f;
      render();
    }).catch(function () {
      songPhotoFile = null;
      if (err) { err.textContent = T.r_photoErrType; err.hidden = false; }
      if (conv) conv.hidden = true;
    });
  }

  function showPhoto(prev) { if (!prev) return; if (photoFile) { prev.innerHTML = '<img src="' + URL.createObjectURL(photoFile) + '" alt="">'; } else { prev.textContent = '🖼'; } }
  function onPhoto(ev) {
    var input = ev.target, err = q('#ymq-p6-err'), prev = q('#ymq-photo-prev'), lbl = q('#ymq-photo-lbl');
    var file = input.files && input.files[0];
    if (err) { err.hidden = true; err.textContent = ''; }
    if (!file) { photoFile = null; showPhoto(prev); return; }
    var isHeic = /heic|heif/i.test(file.type) || /\.(heic|heif)$/i.test(file.name);
    var p = Promise.resolve(file);
    if (isHeic) { if (lbl) lbl.textContent = T.p6_converting; if (prev) prev.textContent = '⏳'; p = convertHeic(file); }
    p.then(function (f) {
      if (lbl) lbl.textContent = T.p6_photoBtn;
      if (f.size > 20 * 1024 * 1024) { throw new Error(T.p6_errPhotoBig); }
      if (!/^image\/(jpe?g|png|webp)$/i.test(f.type)) { throw new Error(T.p6_errPhotoType); }
      photoFile = f; showPhoto(prev);
    }).catch(function (e) {
      if (lbl) lbl.textContent = T.p6_photoBtn;
      photoFile = null; input.value = ''; showPhoto(prev);
      if (err) { err.textContent = (e && e.message) || T.p6_errPhotoType; err.hidden = false; }
    });
  }

  // ============================================================
  //  Bindings
  // ============================================================
  function bindStep(n) {
    if (n === 1) {
      var grid = q('#ymq-recipients');
      grid.addEventListener('click', function (e) {
        var b = e.target.closest('.ymq-opt'); if (!b) return;
        grid.querySelectorAll('.ymq-opt').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        var r = T.recipients[+b.dataset.i];
        A.recipientKey = r.key; A.recipientLabel = r.rel; A.recipientText = r.label; A.cat = r.cat; A.gender = r.g;
        var lb = q('#ymq-namelbl'); if (lb) lb.textContent = questionPrenom();
      });
      var ni = q('#ymq-name');
      ni.addEventListener('input', function () {
        var v = nomPropre(ni.value);
        if (v !== ni.value) ni.value = v;
        A.name = v;
      });
      if (A.recipientKey) grid.querySelectorAll('.ymq-opt').forEach(function (o) { if (T.recipients[+o.dataset.i].key === A.recipientKey) o.setAttribute('aria-pressed', 'true'); });
      var og = q('#ymq-occasions'), oo = q('#ymq-occ-other'), oi = q('#ymq-occother');
      og.addEventListener('click', function (e) {
        var b = e.target.closest('.ymq-chip'); if (!b) return;
        og.querySelectorAll('.ymq-chip').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        A.occasion = b.dataset.occ; oo.hidden = !isOther(A.occasion); if (!oo.hidden) oi.focus();
      });
      oi.addEventListener('input', function () { A.occasionOther = oi.value; });
      if (A.occasion) og.querySelectorAll('.ymq-chip').forEach(function (o) { if (o.dataset.occ === A.occasion) o.setAttribute('aria-pressed', 'true'); });
    } else if (n === 2) {
      var pop = q('#ymq-styles'), extra = q('#ymq-styles-extra');
      function pick(e) {
        var b = e.target.closest('.ymq-chip'); if (!b) return;
        [pop, extra].forEach(function (g) { g.querySelectorAll('.ymq-chip').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); }); });
        A.style = b.dataset.style; A.styleOther = isOther(A.style) ? A.style : '';
      }
      pop.addEventListener('click', pick); extra.addEventListener('click', pick);
      q('#ymq-more').addEventListener('click', function () { extra.hidden = !extra.hidden; this.textContent = extra.hidden ? T.moreStyles : T.lessStyles; });
      var vg = q('#ymq-voices');
      vg.addEventListener('click', function (e) {
        var b = e.target.closest('.ymq-opt'); if (!b) return;
        vg.querySelectorAll('.ymq-opt').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        A.voice = b.dataset.voice;
      });
      if (A.style) { root.querySelectorAll('.ymq-chip').forEach(function (o) { if (o.dataset.style === A.style) o.setAttribute('aria-pressed', 'true'); }); }
      if (A.voice) { vg.querySelectorAll('.ymq-opt').forEach(function (o) { if (o.dataset.voice === A.voice) o.setAttribute('aria-pressed', 'true'); }); }
    } else if (n === 3) {
      var qm = q('#ymq-qmore'); qm.addEventListener('input', function () { A.qmore = qm.value; });
    } else if (n === 4) {
      var ta = q('#ymq-memories'); ta.addEventListener('input', function () { A.memories = ta.value; });
      var td = q('#ymq-diff'); td.addEventListener('input', function () { A.difficulties = td.value; });
    } else if (n === 5) {
      var ta2 = q('#ymq-message'); ta2.addEventListener('input', function () { A.message = ta2.value; });
      var st = q('#ymq-studio'); st.addEventListener('input', function () { A.studio = st.value; });
    } else if (n === 8) {
      var pg = q('#ymq-products'), perso = q('#ymq-perso'), socleRow = q('#ymq-socle-row');
      pg.addEventListener('click', function (e) {
        var b = e.target.closest('.ymq-pcard'); if (!b) return;
        var key = b.dataset.prod; A.u1.product = (A.u1.product === key) ? '' : key;
        if (A.u1.product !== 'plaque') { A.u1.socle = false; var cb = q('#ymq-socle'); if (cb) cb.checked = false; }
        pg.querySelectorAll('.ymq-pcard').forEach(function (o) { o.setAttribute('aria-pressed', o.dataset.prod === A.u1.product ? 'true' : 'false'); });
        perso.hidden = !A.u1.product; socleRow.hidden = A.u1.product !== 'plaque';
        next.innerHTML = libelleCta();
        var err = q('#ymq-p6-err'); if (err) err.hidden = true;
      });
      q('#ymq-socle').addEventListener('change', function () { A.u1.socle = this.checked; });
      q('#ymq-ptitle').addEventListener('input', function () { A.u1.songTitle = this.value; });
      q('#ymq-partist').addEventListener('input', function () { A.u1.artist = this.value; });
      q('#ymq-photo').addEventListener('change', onPhoto);
      showPhoto(q('#ymq-photo-prev'));
    } else if (n === 6) {
      root.querySelectorAll('.ymq-redit').forEach(function (b) {
        b.addEventListener('click', function () {
          var s = parseInt(b.getAttribute('data-step'), 10);
          if (s >= 1 && s < 6) { cur = s; render(); }
        });
      });
      var spIn = q('#ymq-sp-input');
      if (spIn) spIn.addEventListener('change', onSongPhoto);
      showSongPhoto();
    } else if (n === 7) {
      root.querySelectorAll('.ymq-redit').forEach(function (b) {
        b.addEventListener('click', function () {
          var s = parseInt(b.getAttribute('data-step'), 10);
          if (s >= 1 && s < 7) { cur = s; render(); }
        });
      });
      var ex = q('#ymq-express'), st = q('#ymq-streaming'), pa = q('#ymq-paroles'), psi = q('#ymq-ps-img');
      var majDate = function () {
        var dd = q('#ymq-delivdate');
        if (dd) dd.textContent = dateLivraison(joursLivraison());
      };
      if (ex) ex.addEventListener('change', function () { A.u2.delivery = ex.checked ? 'express' : 'standard'; majDate(); });
      if (st) st.addEventListener('change', function () { A.u2.streaming = st.checked; });
      if (pa) pa.addEventListener('change', function () { A.u2.paroles = pa.checked; });
      if (psi && songPhotoFile) { psi.innerHTML = '<img src="' + URL.createObjectURL(songPhotoFile) + '" alt="">'; }
      renderSessions();
    }
  }

  function validateStep1() {
    var el = q('#ymq-s1-err');
    var msg = !A.recipientKey ? T.s1_errRecipient : (!A.name.trim() ? T.s1_errName : '');
    if (!msg) { if (el) el.hidden = true; return true; }
    if (el) { el.innerHTML = '<span class="ymq-err">' + esc(msg) + '</span>'; el.hidden = false; el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    var ni = q('#ymq-name'); if (ni && A.recipientKey && !A.name.trim()) ni.focus();
    return false;
  }
  function exige(sel, cle) {
    var v = (A[cle] || '').trim();
    if (v.length >= 3) return true;
    var el = q(sel);
    if (el) { el.classList.add('ymq-manque'); el.focus(); el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    return false;
  }
  // Etape 2 : un style et une voix, sinon on ne passe pas (meme regle que le quiz extrait).
  function validateStep2() {
    var el = q('#ymq-s2-err');
    var msg = !A.style ? T.s2_errStyle : (!A.voice ? T.s2_errVoice : '');
    if (!msg) { if (el) el.hidden = true; return true; }
    if (el) { el.innerHTML = '<span class="ymq-err">' + esc(msg) + '</span>'; el.hidden = false; el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    return false;
  }
  function validate(n) {
    if (n === 1) return validateStep1();
    if (n === 2) return validateStep2();
    if (n === 3) return exige('#ymq-qmore', 'qmore');
    if (n === 4) return exige('#ymq-memories', 'memories');
    if (n === 5) return exige('#ymq-message', 'message');
    if (n === 8 && A.u1.product) {
      var err = q('#ymq-p6-err');
      if (!A.u1.songTitle.trim() || !A.u1.artist.trim()) { if (err) { err.textContent = T.p6_errFields; err.hidden = false; } return false; }
      if (!photoFile) { if (err) { err.textContent = T.p6_errPhoto; err.hidden = false; } return false; }
    }
    return true;
  }

  // ============================================================
  //  Render + navigation
  // ============================================================
  var host = q('#ymq-step'), stepLbl = q('#ymq-steplabel');
  var back = q('#ymq-back'), skip = q('#ymq-skip'), next = q('#ymq-next'), privEl = q('#ymq-privacy');
  var skippable = { 8: true };   /* l objet deco reste une proposition, pas une question */

  function render() {
    host.innerHTML = stepHTML(cur);
    bindStep(cur);
    if (stepLbl) stepLbl.hidden = true;
    if (privEl) privEl.hidden = (cur !== 1);
    var xex = q('#ymq-examples'), pay = q('#ymq-paybadges'), rev = q('#ymq-reviews'), faq = q('#ymq-faq');
    if (xex) { xex.hidden = (cur !== 6); var xt = q('#ymq-xtitle'); if (xt) xt.textContent = T.x_title || ''; }
    if (pay) pay.hidden = (cur !== 7);
    if (rev) {
      var avisReplies = rev.classList.contains('ymq-reviews--replie');
      var montrerAvis = (cur === 6 || cur === 7);
      rev.classList.toggle('ymq-reviews--replie', !montrerAvis);
      if (avisReplies && montrerAvis) replacerAvis();
    }
    if (faq) {
      faq.hidden = (cur !== 6 && cur !== 7);
      if (!faq.getAttribute('data-rempli')) { faq.innerHTML = faqHTML(); faq.setAttribute('data-rempli', '1'); }
    }
    back.hidden = cur === 1; skip.hidden = !skippable[cur] || cur === MAX;
    back.textContent = '← ' + T.back; skip.textContent = (cur === 8) ? T.skipPhysical : T.skip;
    next.innerHTML = libelleCta();
    var wrap = q('#ymq-wrap'); if (wrap) wrap.style.visibility = 'visible';
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
  }

  next.addEventListener('click', function () {
    if (!validate(cur)) return;
    if (cur < MAX) { cur++; render(); return; }
    submit();
  });
  back.addEventListener('click', function () { if (cur > 1) { cur--; render(); } });
  root.addEventListener('click', function (e) {
    if (cur === 2 && e.target.closest('.ymq-chip, .ymq-opt')) { var el = q('#ymq-s2-err'); if (el) el.hidden = true; }
  });
  skip.addEventListener('click', function () {
    if (cur === 8) { A.u1.product = ''; A.u1.socle = false; }
    if (cur < MAX && skippable[cur]) { cur++; render(); }
  });

  // ============================================================
  //  Panier → checkout (mêmes propriétés de ligne que le quiz v1)
  // ============================================================
  function songProps() {
    var L = T.props, p = {};
    var quals = A.qualities.slice(); if (A.qmore.trim()) quals.push(A.qmore.trim());
    p[L.recipient] = flatten(A.recipientText || A.recipientLabel);
    p[L.firstName] = flatten(A.name);
    p[L.style] = flatten(A.style);
    p[L.voice] = flatten(A.voice);
    p[L.occasion] = flatten(A.occasionOther.trim() ? A.occasionOther : A.occasion);
    p[L.qualities] = flatten(quals.join(', '));
    p[L.memories] = flatten(A.memories);
    p[L.difficulties] = flatten(A.difficulties);
    p[L.message] = flatten(A.message);
    p[L.studio] = flatten(A.studio);
    p['_locale'] = rawLoc;
    p['_quiz_version'] = 'v2';
    Object.keys(p).forEach(function (k) { if (!p[k]) delete p[k]; });
    return p;
  }
  function physicalProps() {
    var L = T.props, p = {};
    p[L.songTitle] = flatten(A.u1.songTitle); p[L.artist] = flatten(A.u1.artist);
    if (A.u1.product === 'plaque' && A.u1.socle) p[L.socle] = L.yes;
    return p;
  }
  function uploadSong(variantId, props) {
    var fd = new FormData();
    fd.append('id', String(variantId)); fd.append('quantity', '1');
    Object.keys(props).forEach(function (k) { if (props[k]) fd.append('properties[' + k + ']', String(props[k])); });
    fd.append('properties[Photo]', songPhotoFile, songPhotoFile.name);
    return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error('song photo ' + r.status + ' ' + t.slice(0, 200)); });
      return r.json();
    });
  }

  function uploadPhysical(variantId, props) {
    var fd = new FormData();
    fd.append('id', String(variantId)); fd.append('quantity', '1');
    Object.keys(props).forEach(function (k) { if (props[k]) fd.append('properties[' + k + ']', String(props[k])); });
    fd.append('properties[Photo]', photoFile, photoFile.name);
    return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error('photo ' + r.status + ' ' + t.slice(0, 200)); });
      return r.json();
    });
  }
  function showErr(msg) { var el = q('#ymq-p7-err'); if (el) { el.textContent = msg; el.hidden = false; el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }

  var submitting = false;
  function submit() {
    if (submitting) return;
    if (!validId(VARIANTS.song)) { showErr('Variant ID manquant pour la chanson (réglages de la section).'); return; }
    submitting = true;
    next.disabled = true; next.classList.add('ymq-loading');
    var hasPhoto = !!(A.u1.product && photoFile);
    next.innerHTML = hasPhoto ? T.uploading : T.submitting;
    var e7 = q('#ymq-p7-err'); if (e7) e7.hidden = true;

    var chain = Promise.resolve();
    if (hasPhoto) {
      var pv = A.u1.product === 'plaque' ? VARIANTS.plaque : VARIANTS.magnet;
      if (!validId(pv)) { chain = Promise.reject(new Error('Variant ID manquant pour ' + A.u1.product)); }
      else chain = chain.then(function () { return uploadPhysical(Number(pv), physicalProps()); });
    }
    if (songPhotoFile) {
      chain = chain.then(function () { return uploadSong(Number(VARIANTS.song), songProps()); });
    }
    chain.then(function () {
      next.innerHTML = T.submitting;
      var items = songPhotoFile ? [] : [{ id: Number(VARIANTS.song), quantity: 1, properties: songProps() }];
      if (A.u1.product === 'plaque' && A.u1.socle && validId(VARIANTS.socle)) items.push({ id: Number(VARIANTS.socle), quantity: 1 });
      if (A.u2.delivery === 'express' && validId(VARIANTS.express)) items.push({ id: Number(VARIANTS.express), quantity: 1 });
      if (A.u2.streaming && validId(VARIANTS.streaming)) items.push({ id: Number(VARIANTS.streaming), quantity: 1 });
      if (A.u2.paroles && validId(VARIANTS.paroles)) items.push({ id: Number(VARIANTS.paroles), quantity: 1 });
      if (!items.length) return Promise.resolve({});
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) }).then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error('cart ' + r.status + ' ' + t.slice(0, 200)); });
        return r.json();
      });
    }).then(function () {
      oublierProgression();
      window.location.href = checkoutUrl;
    }).catch(function (err) {
      console.error('[ym-quiz-p2] submit error', err);
      submitting = false; next.disabled = false; next.classList.remove('ymq-loading'); next.innerHTML = libelleCta();
      showErr(T.errGeneric + (err && err.message ? ' (' + err.message + ')' : ''));
    });
  }

  // ============================================================
  //  Boot
  // ============================================================
  if (privEl) privEl.innerHTML = '🔒 ' + esc(T.privacy);
  reprendreProgression();
  root.addEventListener('input', planifierSauvegarde);
  root.addEventListener('change', planifierSauvegarde);
  root.addEventListener('click', planifierSauvegarde);
  render();
  console.info('[ym-quiz-p2] init locale=' + LOC);

  // ============================================================
  //  ViewContent (Meta) — une seule fois par chargement de page
  // ============================================================
  // Evenement STANDARD, pas trackCustom : Meta n optimise que sur ses evenements
  // standards. Pas d eventID : aucun ViewContent n est emis cote serveur pour cette
  // page, il n y aurait rien a dedoublonner, et un identifiant reutilise d un
  // chargement a l autre ferait disparaitre les vues suivantes.
  (function vueContenu() {
    if (window.__ymViewContentGuided) return;
    window.__ymViewContentGuided = true;
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'ViewContent', {
          content_name: 'YourMelody Guided Creation',
          content_category: 'guided-purchase-quiz',
          currency: 'EUR',
          value: 0.00
        });
      }
    } catch (e) {}
    try {
      if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push({ event: 'view_content', funnel: 'guided-purchase-v2', locale: rawLoc });
      }
    } catch (e) {}
  })();
})();
